import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./CustomerUsage.css";
import Alert from "react-s-alert";
import $ from "jquery";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { UserContext } from "../../UserContext";
import { createRecAcct } from "../PropView/api/CarbonSolutions";
import RECCalc from "./RECCalc";
import OffsetChart from "../Charts/OffsetChart";
import StatusIncompleteDark from "./status_incomplete_dark.png";
import StatusCompleteDark from "./status_complete_dark.png";
import MasterCalc from "../UsageFunctions/MasterCalc";
import PNMCalc from "./PNMCalc";
import BlackHillsCalc from "./BlackHillsCalc";
import OverRideCalc from "./OverRideCalc";
import StateProduction from "./StateProduction";
import UploadFile from "../UploadFile/UploadFile";
import Proposals from "../Proposals/Proposals";
import ReRoofing from "../ReRoofing/ReRoofing";
import moment from "moment";
import Confetti from "react-dom-confetti";
import proposalToolApi from "../PropView/api/proposal-tool-api";
import {
  getPowerWallOptions,
  getExpansionPackCashPrice,
  shouldRenderPowerWall,
  getEnphase10cFirstBatteryAmount,
  getEnphase10cAdditionalBatteryAmount,
} from "../PropView/helper-functions/adders";
import auroraApi from "../../api/aurora-api";
import { Modal } from "../../shared/components/modal/Modal";
import AuroraDesignModal from "./AuroraDesignModal";

function convertToCurrency(value) {
  return value
    .toLocaleString(undefined, {
      style: "currency",
      currency: "USD",
    })
    .split(".")[0];
}

const CustomerUsage = (props) => {
  const { activeUser } = useContext(UserContext);

  const [user, setUser] = useState();

  const [annualProduction, setAnnualProduction] = useState("");

  const [janProduction, setJanProduction] = useState(0);
  const [febProduction, setFebProduction] = useState(0);
  const [marProduction, setMarProduction] = useState(0);
  const [aprProduction, setAprProduction] = useState(0);
  const [mayProduction, setMayProduction] = useState(0);
  const [junProduction, setJunProduction] = useState(0);
  const [julyProduction, setJulyProduction] = useState(0);
  const [augProduction, setAugProduction] = useState(0);
  const [sepProduction, setSepProduction] = useState(0);
  const [octProduction, setOctProduction] = useState(0);
  const [novProduction, setNovProduction] = useState(0);
  const [decProduction, setDecProduction] = useState(0);

  const [img, setImg] = useState("");

  const [panelAmount, setPanelAmount] = useState("");
  const [systemSize, setSystemSize] = useState("");
  const [systemSizeAC, setSystemSizeAC] = useState("");
  const [arrayCount, setArrayCount] = useState("");
  const [systemCost, setSystemCost] = useState("");
  const [hasRebate, setHasRebate] = useState("");
  const [totalProduction, setTotalProduction] = useState("");
  const [loanAmount, setLoanAmount] = useState("");
  const [rebate, setRebate] = useState("");
  const [downPayment, setDownPayment] = useState(0);
  const [stateTax, setStateTax] = useState(0);
  const [maxModCount, setMaxModCount] = useState("");
  const [changeLoans, setChangeLoans] = useState("");

  const [viewAdders, setViewAdders] = useState("");

  // console.log(hasRebate)

  //adders
  const [adderTotal, setAdderTotal] = useState("");
  const [treeRemoval, setTreeRemoval] = useState(0);
  const [reRoof, setReRoof] = useState(0);
  const [reRoofAmount, setReRoofAmount] = useState("");
  const [internalRoofingModalOpen, setInternalRoofingModalOpen] =
    useState(false);
  // Use external state if provided, otherwise use internal state
  const roofingModalOpen =
    props.roofingModalOpen !== undefined
      ? props.roofingModalOpen
      : internalRoofingModalOpen;
  const setRoofingModalOpen =
    props.setRoofingModalOpen || setInternalRoofingModalOpen;
  const [travelAdder, setTravelAdder] = useState(false);
  const [travelAdderAmount, setTravelAdderAmount] = useState(0);
  const [roofSqFt, setRoofSqFt] = useState("");
  const [roofType, setRoofType] = useState("");
  const [roofQuote, setRoofQuote] = useState({
    roofType: "",
    roofQuoteAmount: "",
    roofQuoteId: "",
    sheathing: 0,
    roofImg: "",
  });
  const [roofQuotes, setRoofQuotes] = useState([]);
  const [sheathing, setSheathing] = useState(false);
  const [roofImg, setRoofImg] = useState("");
  const [viewRoofQuotes, setViewRoofQuotes] = useState(false);
  const [smartHome, setSmartHome] = useState("");
  const [smartHomeAmount, setSmartHomeAmount] = useState("");
  const [hvac, setHvac] = useState("");
  const [hvacAmount, setHvacAmount] = useState("");
  const [led, setLed] = useState("");
  const [ledAmount, setLedAmount] = useState("");
  const [turf, setTurf] = useState("");
  const [turfAmount, setTurfAmount] = useState("");
  const [windows, setWindows] = useState("");
  const [windowsAmount, setWindowsAmount] = useState("");
  const [water, setWater] = useState("");
  const [waterAmount, setWaterAmount] = useState("");
  const [treeRemovalAmount, setTreeRemovalAmount] = useState("");
  const [travel, setTravel] = useState(0);
  const [dealerFee, setDealerFee] = useState(props.loan1[9]);
  const [previousDealerFee, setPreviousDealerFee] = useState(props.loan1[9]);
  const [utilityReview, setUtilityReview] = useState(false);
  const [utilityReviewAmount, setUtilityReviewAmount] = useState(
    1250 / +dealerFee,
  );
  const [travelAmount, setTravelAmount] = useState(0.1 / +dealerFee);
  const [ballastAmount, setBallastAmount] = useState(0.23 / +dealerFee);
  const [pSolarAmount, setPSolarAmount] = useState(
    roundAndFormatNumber(0.15 / +dealerFee, 4),
  );
  const [groundMountAmount, setGroundMountAmount] = useState(1.3);
  const [mspAmount, setMspAmount] = useState(3500 / +dealerFee);
  const [newMspAmount, setNewMspAmount] = useState(3500 / +dealerFee);
  const [critterGuardAmount, setCritterGuardAmount] = useState(
    0.1 / +dealerFee,
  );
  // const [critterGuardAmount, setCritterGuardAmount] = useState(.06 / +dealerFee)
  const [battery3Amount] = useState(4500);
  const [battery10Amount, setBattery10Amount] = useState(0);
  const [powerWallAmount, setPowerWallAmount] = useState(12500 / +dealerFee);
  const [addBattery10Amount, setAddBattery10Amount] = useState(12500);
  const [ballast, setBallast] = useState(0);
  const [ballastTotal, setBallastTotal] = useState("");
  const [partialBallast, setPartialBallast] = useState(0);
  const [ballastPanels, setBallastPanels] = useState("");
  const [partialGroundMount, setPartialGroundMount] = useState(0);
  const [groundMountPanels, setGroundMountPanels] = useState("");
  const [groundMountTotal, setGroundMountTotal] = useState("");
  const [pSolar, setPSolar] = useState(0);
  const [groundMount, setGroundMount] = useState(0);
  const [msp, setMsp] = useState(0);
  const [critterGuard, setCritterGuard] = useState(0);
  const [military, setMilitary] = useState(0);
  const [miscCash, setMiscCash] = useState(0);
  const [miscCashAmount, setMiscCashAmount] = useState(0);
  const [loadSwitch, setLoadSwitch] = useState(0);
  const [loadSwitchAmount, setLoadSwitchAmount] = useState(1500 / +dealerFee);
  const [miscCashNotes, setMiscCashNotes] = useState("");
  const [freePower, setFreePower] = useState(0);
  const [blackFriday, setBlackFriday] = useState(0);
  const [battery3, setBattery3] = useState(0);
  const [battery10, setBattery10] = useState(0);
  const [powerWall, setPowerWall] = useState(0);
  const [propPpw, _setPropPpw] = useState("");
  const [grossPpw, setGrossPpw] = useState("");
  const [netPpw, setNetPpw] = useState("");
  const [selectedPpw, setSelectedPpw] = useState("");
  const [basePpw, setBasePpw] = useState("");
  const [inputBasePpw, setInputBasePpw] = useState("");
  const [ppw, _setPpw] = useState("");
  const [clone, setClone] = useState(0);
  const [overRide, setOverRide] = useState(false);
  const [costOverRide, setCostOverRide] = useState("");
  const [systemCostOverRide, setSystemCostOverRide] = useState("");
  const [smallSystemAdder, setSmallSystemAdder] = useState(false);
  const [smallSystemAdderAmount, setSmallSystemAdderAmount] = useState(0);
  const [adderAmount, setAdderAmount] = useState(500 / +dealerFee);
  const [ionRebate, setIonRebate] = useState("");
  const [ionRebate2, setIonRebate2] = useState("");
  const [blkAdder, setBlkAdder] = useState("");
  const [blkAdderAmount, setBlkAdderAmount] = useState(500 / +dealerFee);
  const [panelBonus, setPanelBonus] = useState(0);
  const [panelBonusAmount, setPanelBonusAmount] = useState(357.14);
  const [nest, setNest] = useState("");
  const [nestAmount, setNestAmount] = useState(2076);
  const [nestCost, setNestCost] = useState(250 / +dealerFee);
  const [nestMax, setNestMax] = useState(0.05);
  const [propRatio, setPropRatio] = useState("");
  const [rateOverRide, setRateOverRide] = useState(0);
  const [rateOverRideAmount, setRateOverRideAmount] = useState("");
  const [modules, setModules] = useState([]);
  const [mod, setMod] = useState("");
  const [inverter, setInverter] = useState("");
  const [inverters, setInverters] = useState([]);
  const [modEdit, setModEdit] = useState("");
  const [invEdit, setInvEdit] = useState("");
  const [customRate, setCustomRate] = useState("");
  const [rebateSF, setRebateSF] = useState("");
  const [rebateOverride, setRebateOverride] = useState("0");
  const [rebateOverrideAmt, setRebateOverrideAmt] = useState("");
  const [partialRebate, setPartialRebate] = useState(0);
  const [partialPanels, setPartialPanels] = useState("");
  const [cash, setCash] = useState("");
  const [displayProd, setDisplayProd] = useState("");
  const [timeStamp, setTimeStamp] = useState("");
  const [panelEstimate, setPanelEstimate] = useState("");
  // const [maximumOverDrive, setMaximumOverDrive] = useState('')
  const [goConfetti, setGoConfetti] = useState(false);
  const [highLoan, setHighLoan] = useState("");
  const [preferredUtility, setPreferredUtility] = useState(0);
  const [preferredUtilityAmount, setPreferredUtilityAmount] = useState(0.4);
  const [sameDay, setSameDay] = useState(0);
  const [sameDayAmount, setSameDayAmount] = useState(1000);
  const [referral, setReferral] = useState(0);
  const [referralAmount, setReferralAmount] = useState(1500);
  const [nestAdder, setNestAdder] = useState(0);
  const [nestAdderAmount, setNestAdderAmount] = useState(100);
  const [sustainable, setSustainable] = useState(0);
  const [sustainableAmount, setSustainableAmount] = useState(200);
  const [viewOptions, setViewOptions] = useState(0);
  const [proposals, setProposals] = useState([]);
  const [hasRec, setHasRec] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [acCoupled, setAcCoupled] = useState(0);
  const [showAuroraDesignModal, setShowAuroraDesignModal] = useState(false);
  const [auroraDesigns, setAuroraDesigns] = useState([]);
  const [loadingDesigns, setLoadingDesigns] = useState(false);
  const [syncedAuroraDesignId, setSyncedAuroraDesignId] = useState(null);
  const [acCoupledAmount, setAcCoupledAmount] = useState(1500 / +dealerFee);
  const [permittingAdder, setPermittingAdder] = useState(0);
  const [permittingAdderAmount, setPermittingAdderAmount] = useState(
    0.1 / +dealerFee,
  );
  const [waterSoftener, setWaterSoftener] = useState(0);
  const [waterSoftenerAmount, setWaterSoftenerAmount] = useState(
    4000
  );

  const [loanA, setLoanA] = useState("");
  const [loanB, setLoanB] = useState("");

  const [loanProducts, setLoanProducts] = useState([]);

  const [setterAmount] = useState(0.2);

  let inverterCount = powerWall ? 1 : panelAmount;

  const [imagery, setImagery] = useState("");
  const [meterAgg, setMeterAgg] = useState("");
  const [sharedHome, setSharedHome] = useState("");
  const [storyAmount, setStoryAmount] = useState("");
  const [townhome, setTownhome] = useState("");
  const [townhomeAmount, setTownhomeAmount] = useState(400 / +dealerFee);
  const [trenching, setTrenching] = useState("");
  const [addon, setAddon] = useState("");
  const [designLimited, setDesignLimited] = useState("");
  const [addShadeWaiver, setAddShadeWaiver] = useState("");
  const [expansionPack, setExpansionPack] = useState(false);
  const [expansionPackAmount, setExpansionPackAmount] = useState(0);
  const [pvSystemAddOn, setPvSystemAddOn] = useState("");
  const [pvSystemAddOnAmount, setPvSystemAddOnAmount] = useState(
    1000 / +dealerFee,
  );

  //Prod
  const apiUrl = proposalToolApi.getUrl();

  useEffect(() => {
    // set the user first name and last name
    setUser(
      `${activeUser.attributes.given_name} ${activeUser.attributes.family_name}`,
    );

    // fetch data required for the proposal tool
    getLoanProducts();
    getModules();
    getInverters();
  }, []);

  useEffect(() => {
    if (!dealerFee) return;

    const cost = (() => {
      if (+nest === 0) return 0;
      if (+nest === 1) return 250 / +dealerFee;
      if (+nest === 2) return 450 / +dealerFee;

      return 250 / +dealerFee;
    })();

    setNestCost(cost);
  }, [nest, dealerFee]);

  useEffect(() => {
    if (img) {
      setTimeStamp(moment().format("MM/DD/YY, h:mm a"));
    }
  }, [img]);

  useEffect(() => {
    setRoofSqFt(props.customer.roofSqFootage);
  }, [props.customer.roofSqFootage]);

  const getLoanProducts = () => {
    axios
      .post(apiUrl, { method: "get_loan_products" })
      .then((res) => {
        const raw = res.data?.data;
        setLoanProducts(Array.isArray(raw) ? raw : []);
      })
      .catch((err) => {
        console.error("get_loan_products failed:", err);
        setLoanProducts([]);
      });
  };

  const getModules = () => {
    axios
      .post(apiUrl, { method: "get_modules" })
      .then((res) => {
        const raw = res.data?.data;
        setModules(Array.isArray(raw) ? raw : []);
      })
      .catch((err) => {
        console.error("get_modules failed:", err);
        setModules([]);
      });
  };

  const getInverters = () => {
    axios
      .post(apiUrl, { method: "get_inverters" })
      .then((res) => {
        const raw = res.data?.data;
        setInverters(Array.isArray(raw) ? raw : []);
      })
      .catch((err) => {
        console.error("get_inverters failed:", err);
        setInverters([]);
      });
  };

  const createProposal = () => {
    axios
      .post(apiUrl, {
        method: "create_proposal",
        project_id: props.projectID,
        prop_size: systemSize,
        mod_count: panelAmount,
        og_mod_count: panelAmount,
        max_mod_count: maxModCount,
        inv_count: inverterCount,
        total_system_cost: Math.ceil(systemCost),
        prop_loan_amount: loanAmount,
        down_payment: downPayment,
        has_nest: nest,
        rebate_amount: rebate,
        rebate_in_sf: rebateSF,
        rebate_override: rebateOverride,
        rebate_panels: partialPanels,
        array_count: arrayCount,
        prop_ppw: propPpw,
        gross_ppw: grossPpw,
        net_ppw: netPpw,
        selected_ppw: selectedPpw,
        cost_override: systemCostOverRide,
        prop_design: img,
        ballast: ballast,
        ballast_amount: ballastAmount,
        ballast_panels: ballastPanels,
        ground_mount: groundMount,
        ground_mount_amount: groundMountAmount,
        ground_mount_panels: groundMountPanels,
        p_solar: pSolar,
        p_solar_amount: pSolarAmount,
        travel: 0,
        travel_amount: 0,
        tree_trim: treeRemoval,
        trim_amount: treeRemovalAmount,
        reroof: reRoof,
        reroof_amount: reRoofAmount,
        ion_rebate: ionRebate,
        ion_rebate2: blkAdder,
        msp: msp,
        msp_amount: newMspAmount,
        critter_guard: critterGuard,
        critter_guard_amount: critterGuardAmount,
        battery3: battery3,
        battery10: battery10,
        battery10_amount: battery10Amount,
        rate_override: rateOverRide,
        rate_amount: rateOverRideAmount,
        jan: janProduction,
        feb: febProduction,
        mar: marProduction,
        apr: aprProduction,
        may: mayProduction,
        june: junProduction,
        july: julyProduction,
        aug: augProduction,
        sept: sepProduction,
        oct: octProduction,
        nov: novProduction,
        december: decProduction,
        prop_ratio: propRatio,
        mod_id: mod[0],
        inv_id: inverter[0],
        utility_id: utilityId,
        loan_id1: loanA[0],
        loan_id2: loanB[0],
        time_stamp: timeStamp,
        rep_gen: 0,
        cost_25_yr: cost25yr,
        curr_ann_bill: currAnnBill,
        today: today,
        yr_5: yr5,
        yr_10: yr10,
        yr_15: yr15,
        yr_20: yr20,
        yr_25: yr25,
        gallon: gallon,
        home: home,
        garbage: garbage,
        tree: tree,
        display_prod: +displayProd,
        nest_impact: nestImpact,
        utility_power: utilityPower,
        solar_power: solarPower,
        jan_u: janU,
        feb_u: febU,
        mar_u: marU,
        apr_u: aprU,
        may_u: mayU,
        jun_u: junU,
        july_u: julyU,
        aug_u: augU,
        sep_u: sepU,
        oct_u: octU,
        nov_u: novU,
        dec_u: decU,
        jan_p: janP,
        feb_p: febP,
        mar_p: marP,
        apr_p: aprP,
        may_p: mayP,
        jun_p: junP,
        july_p: julyP,
        aug_p: augP,
        sep_p: sepP,
        oct_p: octP,
        nov_p: novP,
        dec_p: decP,
        pmt_1: pmt1,
        pmt_2: pmt2,
        pmt_3: pmt3,
        state_tax: stateTax,
        net_cost: netCost,
        itc_total: itcTotal,
        all_incentives: allIncentives,
        avg_25_utility: avg25Utility,
        avg_25_1: avg25_1,
        avg_25_2: avg25_2,
        pmt_1_b: pmt1B,
        pmt_2_b: pmt2B,
        loan_1_savings: loan1Savings,
        loan_2_savings: loan2Savings,
        ion_cost_a: ionCostA,
        ion_cost_b: ionCostB,
        remaining_cost: remainingCost,
        current_per_kw: currentPerKw,
        same_day: sameDay,
        preferred_utility: preferredUtility,
        referral: referral,
        has_nest_adder: nestAdder,
        team_ppw: team.ppw,
        sustainable: sustainable,
        smart_home: smartHome,
        smart_home_amt: smartHomeAmount,
        hvac: hvac,
        hvac_amt: hvacAmount,
        led: led,
        led_amt: ledAmount,
        turf: turf,
        turf_amt: turfAmount,
        windows: windows,
        windows_amt: windowsAmount,
        water: water,
        water_amt: waterAmount,
        military: military,
        misc_cash: miscCash,
        misc_cash_amount: miscCashAmount,
        adder_total: adderTotal,
        user: user,
        misc_cash_notes: miscCashNotes,
        free_months: freePower,
        shade_waiver: addShadeWaiver,
        options_view: viewOptions,
        panel_bonus: panelBonus,
        townhome: townhome,
        srec: hasRec,
        utility_review: utilityReview,
        utility_review_amount: utilityReviewAmount,
        travel_adder_amount: travelAdderAmount,
        travel_adder_tier:
          +props.customer.travelDistance < 76
            ? ""
            : +props.customer.travelDistance <= 100
              ? "Tier 1: 76-100 Miles"
              : +props.customer.travelDistance <= 125
                ? "Tier 2: 101-125 Miles"
                : "Tier 3: 126-150 Miles",
        financeId: props.customer.financeId,
        pv_system_add_on: pvSystemAddOn,
        pv_system_add_on_amount: pvSystemAddOnAmount,
        expansion_pack: expansionPack,
        expansion_pack_amount: expansionPackAmount,
        ac_coupled: acCoupled,
        ac_coupled_amount: acCoupledAmount,
        permitting_adder: permittingAdder,
        permitting_adder_amount: permittingAdderAmount,
        water_softener: waterSoftener,
        water_softener_amount: waterSoftenerAmount,
        ...(syncedAuroraDesignId && { aurora_design_id: syncedAuroraDesignId }),
      })
      .then((res) => {
        Alert.success(`${systemSize / 1000}kW Proposal Created`, {
          position: "top-right",
          effect: "flip",
          beep: false,
          timeout: 5000,
          offset: 100,
          color: "rgba(255, 255, 255, 0.927)",
        });
        props.setView(!props.view);
        setGoConfetti(false);
      });
  };

  const addRoofQuote = () => {
    axios
      .post(apiUrl, {
        method: "add_roof_quote",
        project_id: projectID,
        roof_sq_ft: roofSqFt,
        quote_amount: reRoofAmount,
        roof_type: roofType,
        sheathing: sheathing,
        roofImg: roofImg,
      })
      .then((res) => {
        // console.log(res.data)
      });
  };

  const confetti = () => {
    const config = {
      angle: "360",
      spread: "360",
      startVelocity: 45,
      elementCount: "200",
      dragFriction: "0.01",
      duration: 3000,
      stagger: "0",
      width: "10px",
      height: "10px",
      colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
    };
    return <Confetti active={goConfetti} config={config} />;
  };

  function roundAndFormatNumber(num, dec) {
    var formattedNumber = num;
    for (let i = 0; i < dec; i++) {
      formattedNumber = formattedNumber * 10;
    }
    formattedNumber = Math.ceil(formattedNumber);
    for (let i = 0; i < dec; i++) {
      formattedNumber = formattedNumber / 10;
    }
    return formattedNumber;
  }

  const adderToggleBoolean = (bool, operation) => {
    if (bool === true) {
      return operation(false);
    }
    operation(true);
  };

  const adderToggle = (num, operation) => {
    if (num === 1 || num === 2) {
      
      return operation(0);
    }
    operation(1);
  };

  const adderToggleOregon = (num, operation, number) => {
    if (+num > 0) {
      return operation(0);
    }
    operation(number);
  };

  const handleBatteryClick = () => {
    setPowerWall(0);
    if (battery10 > 0) {
      setBattery10(0);
    } else {
      setBattery10(21);
      setBattery10Amount(
        getEnphase10cFirstBatteryAmount(props.customer.state) / +dealerFee,
        // getEnphase10cAmount(21, props.customer.state) / +dealerFee
      );
    }
  };

  const adderToggle2 = (num, operation) => {
    if (num === 1 || num === 2) {
      return operation(0);
    }
    operation(2);
  };

  const adderToggleNest = (num, operation) => {
    if (num === 1 || num === 2) {
      return operation(0);
    }
    operation(1);
  };

  const handlePowerWallClick = (e) => {
    if (battery10 < 11 || battery10 > 20) {
      setPowerWall(1);
      setBattery10(11);
      const basePricing = getPowerWallOptions(props.customer.state)[0].value;
      setBattery10Amount(basePricing / +dealerFee);
    } else {
      setPowerWall(0);
      setBattery10(0);
      setExpansionPack(0);
      setExpansionPackAmount(0);
      setBattery10Amount(0);
    }
  };

  useEffect(() => {
    if (expansionPack > 0) {
      const basePricingEp = getExpansionPackCashPrice(props.customer.state);
      setExpansionPackAmount(basePricingEp / +dealerFee);
    }
  }, [expansionPack, props.customer.state, dealerFee]);

  useEffect(() => {
    if (props.jurisdiction?.toLowerCase().includes("portland")) {
      setPermittingAdder(1);
      setPermittingAdderAmount(0.1 / +dealerFee);
    } else {
      setPermittingAdder(0);
      setPermittingAdderAmount(0);
    }
  }, [props.jurisdiction, dealerFee]);

  // ac coupled logic
  useEffect(() => {
    if (+loanA.isPpa === 1 && +battery10 >= 11 && +battery10 < 20) {
      setAcCoupled(+battery10 - 10);
      setAcCoupledAmount((1500 * (+battery10 - 10)) / +dealerFee);
    } else if (
      +loanA.isPpa !== 1 &&
      +pvSystemAddOn > 0 &&
      +battery10 >= 11 &&
      +battery10 < 20
    ) {
      setAcCoupled(+battery10 - 10);
      setAcCoupledAmount((1500 * (+battery10 - 10)) / +dealerFee);
    } else {
      setAcCoupled(false);
      setAcCoupledAmount(0);
    }
  }, [loanA, battery10, pvSystemAddOn, dealerFee]);

  const isUsingOldPayscale = () => {
    if (!currentProp?.contractSigned) {
      return false;
    }

    const date = new Date(currentProp?.contractSigned);
    return date < new Date("2025-09-16");
  };

  const addDealerFee = (selectedPpw) => {
    if (isUsingOldPayscale()) {
      return selectedPpw;
    }

    return Number(selectedPpw / dealerFee || 0);
  };

  const removeDealerFee = (selectedPpw) => {
    if (isUsingOldPayscale()) {
      return selectedPpw;
    }

    return Number(selectedPpw * dealerFee || 0);
  };

  const calculatedGrossPpw = (curLoan) => {
    if (curLoan.loanName === "LightReach PPA") {
      let systemPrice = curLoan?.totalAmount;
      return Number(systemPrice / systemSize || 0);
    }

    let systemPrice = ppw * systemSize;

    if (+curLoan.isPpa) {
      return ppw;
    }

    return Number((systemPrice + adderTotal) / systemSize || 0);
  };

  const calculatedNetPpw = (curLoan) => {
    if (+curLoan.isPpa) {
      const solarCost = Number(curLoan.totalAmount || 0);

      if (solarCost === 0) {
        return 0;
      }

      const solarMinusAddersPpw = (solarCost - adderTotal) / systemSize;
      return Number(solarMinusAddersPpw || 0);
    }

    return Number(ppw * dealerFee || 0);
  };

  const setPpw = (value = null, dealerFeeAlreadyIncluded = true) => {
    const curLoan = loanProducts.find((loan) => +loan.loanId === +loanA[0]);
    if (value) {
      value = value;
    } else {
      value = ppw;
      dealerFeeAlreadyIncluded = true;
    }

    if (value === null || value === undefined || value === "" || value === 0) {
      return;
    }

    const ppwWithoutDealerFee = dealerFeeAlreadyIncluded
      ? removeDealerFee(value)
      : value;
    const ppwValueWithFee = dealerFeeAlreadyIncluded
      ? value
      : addDealerFee(value);

    setSelectedPpw(ppwWithoutDealerFee);
    _setPpw(ppwValueWithFee);
    if (curLoan) {
      setNetPpw(calculatedNetPpw(curLoan));
      setGrossPpw(calculatedGrossPpw(curLoan));
    }
  };

  useEffect(() => {
    setPpw();
  }, [ppw, adderTotal, systemSize, loanA, dealerFee]);

  const setPropPpw = (value = null, dealerFeeAlreadyIncluded = true) => {
    setPpw(value, dealerFeeAlreadyIncluded);
    _setPropPpw(+ppw);
  };
  // set default battery and expansion pack amounts
  useEffect(() => {
    // set default battery amount
    if (!battery10Amount) {
      const basePricing = getPowerWallOptions(props.customer.state)[0].value;
      setBattery10Amount(basePricing / +dealerFee);
    }

    // set default expansion pack amount
    if (!expansionPackAmount) {
      const basePricing = getExpansionPackCashPrice(props.customer.state);
      setExpansionPackAmount(basePricing / +dealerFee);
    }
  }, [battery10, props.customer.state, loanA.isPpa, dealerFee]);

  const isSelectedFinancePpa = useMemo(() => {
    if (loanA && +loanA.isPpa === 1) {
      return true;
    }
    const loanId = loanA?.[0] ?? loanA?.loanId;
    if (loanId != null && loanProducts.length) {
      const curLoan = loanProducts.find((loan) => +loan.loanId === +loanId);
      if (curLoan && +curLoan.isPpa === 1) {
        return true;
      }
    }
    const loanName = loanA?.[1] ?? loanA?.loanName ?? "";
    return (
      typeof loanName === "string" &&
      (loanName.includes("PPA") || loanName.includes("TPO"))
    );
  }, [loanA, loanProducts]);

  const handlePowerWallAmountChange = (e) => {
    setBattery10Amount(+e.target.value);
  };

  const handlePowerWallQuantityChange = (e) => {
    setBattery10(10 + +e.target.value);
  };

  // Destructuring
  // const { january, february, march, april, may, june, july, august, september, october, november, december } = props.usage
  const {
    loan1,
    term1,
    interest1,
    post1,
    pre1,
    int1,
    dealerfee1,
    id1,
    itc1,
    specialPrice1,
    loan2,
    term2,
    interest2,
    post2,
    pre2,
    int2,
    dealerfee2,
    id2,
    itc2,
    specialPrice2,
    loan3,
    term3,
    interest3,
    post3,
    pre3,
    int3,
    dealerfee3,
    id3,
    itc3,
    specialPrice3,
    specialLoanIncrease,
    loanOptions,
  } = props.loan;

  const {
    maxOffset,
    maxSystemSize,
    hasAdder,
    irradiance,
    rebateType,
    rebatePerWatt,
    rebateFixed,
    rebateMax,
    utilityLocation,
    utilityId,
    hasNest,
    cashPpw,
    hasUtilityDiscount,
    utilityLseId,
    utilityPpa,
  } = props.rebate;

  const {
    modSize,
    invRating,
    invId,
    invModel,
    invType,
    modPtcRating,
    modId,
    module,
    mod_model,
  } = props.equipment;

  const {
    setUtility,
    usageType,
    step,
    salesTeam,
    team,
    surveyType,
    stories,
    loanChangeSize,
    loanChangeIncrease,
    currentProp,
    salesRep,
    designType,
    limitedSpace,
    city,
    jurisdiction,
  } = props;

  const {
    tierType,
    surcharge,
    tax,
    tier1,
    tier2,
    tier3,
    tier4,
    sTier1,
    sTier2,
    sTier3,
    sTier4,
    wTier1,
    wTier2,
    wTier3,
    wTier4,
    tierAmount,
    sTierAmount,
    wTierAmount,
    tier1Amount,
    tier2Amount,
    tier3Amount,
    tier4Amount,
    sTier1Amount,
    sTier2Amount,
    sTier3Amount,
    sTier4Amount,
    wTier1Amount,
    wTier2Amount,
    wTier3Amount,
    wTier4Amount,
  } = props.calculation;

  let calcs = [
    tierType,
    +surcharge,
    +tax,
    +tier1,
    +tier2,
    +tier3,
    +tier4,
    +sTier1,
    +sTier2,
    +sTier3,
    +sTier4,
    +wTier1,
    +wTier2,
    +wTier3,
    +wTier4,
    +tierAmount,
    +sTierAmount,
    +wTierAmount,
    +tier1Amount,
    +tier2Amount,
    +tier3Amount,
    +tier4Amount,
    +sTier1Amount,
    +sTier2Amount,
    +sTier3Amount,
    +sTier4Amount,
    +wTier1Amount,
    +wTier2Amount,
    +wTier3Amount,
    +wTier4Amount,
  ];

  const propCloning = {
    setBasePpw,
    setUtility,
    setCostOverRide,
    setPartialPanels,
    setPartialRebate,
    setSustainable,
    setRebate,
    setRebateOverride,
    setRebateOverrideAmt,
    setOverRide,
    setPanelAmount,
    setMaxModCount,
    setArrayCount,
    setPpw,
    setPropPpw,
    setClone,
    setDownPayment,
    setIonRebate,
    setBlkAdder,
    setBallast,
    setBallastPanels,
    setPartialBallast,
    setGroundMount,
    setGroundMountPanels,
    setPartialGroundMount,
    setPSolar,
    setMsp,
    setBattery3,
    setBattery10,
    setCritterGuard,
    setTravel,
    setTravelAmount,
    setReRoof,
    setReRoofAmount,
    setTreeRemoval,
    setTreeRemovalAmount,
    setSameDay,
    setPreferredUtility,
    setReferral,
    setJanProduction,
    setFebProduction,
    setMarProduction,
    setAprProduction,
    setMayProduction,
    setJunProduction,
    setJulyProduction,
    setAugProduction,
    setSepProduction,
    setOctProduction,
    setNovProduction,
    setDecProduction,
    setNest,
    setNestAdder,
    setImg,
    setLoanA,
    setLoanB,
    setMod,
    setInverter,
    setRateOverRide,
    setRateOverRideAmount,
    setSmartHome,
    setHvac,
    setLed,
    setTurf,
    setWindows,
    setWater,
    setSmartHomeAmount,
    setHvacAmount,
    setLedAmount,
    setTurfAmount,
    setWindowsAmount,
    setWaterAmount,
    setViewAdders,
    setMilitary,
    setMiscCash,
    setMiscCashAmount,
    setMiscCashNotes,
    setBlackFriday,
    setHasRebate,
    setBallastAmount,
    setCritterGuardAmount,
    setMspAmount,
    setNewMspAmount,
    setPSolarAmount,
    setBattery10Amount,
    setGroundMountAmount,
    setAddShadeWaiver,
    setViewOptions,
    setRoofSqFt,
    setRoofType,
    setSheathing,
    setPanelBonus,
    setHasRec,
    setUtilityReview,
    setUtilityReviewAmount,
    setDealerFee,
    setPvSystemAddOn,
    setPvSystemAddOnAmount,
    setExpansionPack,
    setExpansionPackAmount,
    setPermittingAdder,
    setPermittingAdderAmount,
    setWaterSoftener,
    setWaterSoftenerAmount,
  };

  useEffect(() => {
    if (+pvSystemAddOn === 1) {
      return setPvSystemAddOnAmount(1000 / +dealerFee);
    }
    if (+pvSystemAddOn === 0) {
      return setPvSystemAddOnAmount(0);
    }
  }, [pvSystemAddOn]);

  useEffect(() => {
    if (
      [
        "OH BLK Sales Team",
        "HTX BLK Sales Team",
        "H-Town BLK Sales Team",
      ].includes(salesTeam)
    ) {
      setBlkAdder(2);
    }
  }, [salesTeam]);

  useEffect(() => {
    if (clone !== 1) {
      if (+mod[0] === 19) {
        if (
          [
            "Development Sales Team",
            "Portland Sales Team",
            "Salem Sales Team",
            "Houston Sales Team",
            "Virginia Beach Sales Team",
            "Hampton Sales Team",
            "TX BLK Sales Team",
            "Austin Sales Team",
            "Richmond Sales Team",
            "STX Sales Team",
          ].includes(salesTeam)
        ) {
          return setPanelBonus(2);
        }
      }
      setPanelBonus(0);
    }
  }, [salesTeam, mod]);

  useEffect(() => {
    if (+ballast === 1) {
      return setCritterGuard(0);
    }
  }, [salesTeam, ballast]);

  useEffect(() => {
    props.setNvSqFoot(
      Math.floor((+props.squareFootage * 2.8) / (mod[4] * inverter[3])),
    );
  }, [mod[4]]);

  let surveyTypes;
  if (surveyType) {
    surveyTypes = surveyType.split(";");
  }

  const mappedAdders = props.adders.map((adder, i) => {
    return (
      <div key={i}>
        <span>
          {adder.name === "Adder" ||
          adder.name === "Home Energy Efficiency Upgrade"
            ? adder.type
            : adder.name}{" "}
          {adder.name === "Thermostat (Free)" ? adder.type : ""}{" "}
          {adder.name === "Thermostat (Free)" ||
          adder.name === "LED Light Bulbs (Free)"
            ? Math.round(adder.quantity)
            : adder.type === "Tree Removal" ||
                adder.type === "Reroof" ||
                adder.type === "Pool Solar" ||
                adder.name === "Home Energy Efficiency Upgrade"
              ? `Quote: $${Math.round(adder.amount)} Fee: $${Math.round(
                  adder.fee,
                )} Total: $${Math.round(adder.totalAmount)}`
              : adder.name === "Rep Cash Bonus" ||
                  adder.name === "Travel Adder" ||
                  adder.type === "Engineering/Permitting"
                ? `$${Math.round(adder.amount)} (Internal - not displayed on CIA)`
                : adder.type === "Battery - Encharge 10" ||
                    adder.type === "Service Panel Replacement" ||
                    adder.name === "Military Discount (Check sent at PTO)" ||
                    adder.name === "MISC Cash" ||
                    adder.name === "BlackFriday"
                  ? `$${Math.round(adder.totalAmount)}`
                  : adder.name === "Cash (Check sent at PTO)"
                    ? `$${adder.amount}`
                    : adder.type === "Service Panel Replacement - Utah" ||
                        adder.type === "Service Panel Replacement - Oregon"
                      ? "$1000"
                      : ""}
        </span>
        {/* <IconButton aria-label="delete" style={{ color: `rgb(130, 48, 48)` }} onClick={() => removeIncentive()}>
        <DeleteIcon fontSize="small" />
      </IconButton> */}
      </div>
    );
  });

  // useEffect(() => {
  //   if (clone !== 1) {
  //     if (utilityLocation === 'Utah' || utilityLocation === 'Oregon') {
  //       setNewMspAmount(6000)
  //     }
  //     if (utilityLocation === 'Nevada') {
  //       setNewMspAmount(5500)
  //     }
  //   }
  // }, [utilityLocation])

  // useEffect(() => {
  //   if (nest === 2) {
  //     return setNestMax(.05)
  //   }
  //   if (nest === 1) {
  //     return setNestMax(.1)
  //   }
  // }, [nest])
  // Set the ionRebate for Virginia and South Carolina customers
  useEffect(() => {
    if (["Virginia", "South Carolina", "Maryland"].includes(props.customer.state)) {
      if (props.customer.insideSalesSetter) {
        return; // Do not auto-add Rep/Customer rebate for inside sales setter
      }
      if (!props.customer.setter) {
        return setIonRebate(2); // Rep Cash Bonus
      }

      return setIonRebate(3); // Setter Cash Bonus
    }
  }, [props.customer, ppw, basePpw, ionRebate]);

  useEffect(() => {
    setPpw(+props.ppw);
  }, [props.ppw]);

  useEffect(() => {
    if (+props.customer.travelAdder > 0) {
      setTravelAdder(true);
      setTravelAdderAmount(
        (+props.customer.travelAdder * +systemSize) / +dealerFee,
      );
    } else {
      setTravelAdder(false);
    }
  }, [props, systemSize, dealerFee]);

  useEffect(() => {
    if (+loanA[0] === 115 || loanA[1] === "Flic") {
      return setViewOptions(1);
    }
    setViewOptions(0);
  }, [loanA]);

  useEffect(() => {
    setNest(+hasNest);
    setPreferredUtility(+hasUtilityDiscount);
  }, [props.rebate]);

  // console.log(preferredUtility)

  useEffect(() => {
    setMod([modId, module, mod_model, modSize, modPtcRating]);
    setInverter([invId, invType, invModel, +invRating]);
  }, [props.equipment]);

  // console.log(inverter, inverters)

  // inverter[0] = id
  // inverter[1] = type
  // inverter[2] = model
  // inverter[3] = effRating

  // useEffect(() => {
  //   setMaxSystem(+maxSystemSize)
  // }, [props.loan])

  // console.log(props)

  useEffect(() => {
    if (
      props.utility === "City Public Service (CPS)" ||
      props.utility === "Austin Energy"
    ) {
      setLoanA(props.loan1);
      setLoanB(props.loan2);
    } else {
      setLoanA([
        +id1,
        loan1,
        term1,
        +int1,
        +pre1,
        +post1,
        +interest1,
        +itc1,
        +specialPrice1,
        +dealerfee1,
      ]);
      setLoanB([
        +id2,
        loan2,
        term2,
        +int2,
        +pre2,
        +post2,
        +interest2,
        +itc2,
        +specialPrice2,
        +dealerfee2,
      ]);
    }
  }, [props.equipment, props.loan, props.loan1, props.loan2, props.utility]);

  let usage = props.usage;
  let production = [
    +janProduction,
    +febProduction,
    +marProduction,
    +aprProduction,
    +mayProduction,
    +junProduction,
    +julyProduction,
    +augProduction,
    +sepProduction,
    +octProduction,
    +novProduction,
    +decProduction,
  ];

  let currentUsage = [
    +props.preUsage.january,
    +props.preUsage.february,
    +props.preUsage.march,
    +props.preUsage.april,
    +props.preUsage.may,
    +props.preUsage.june,
    +props.preUsage.july,
    +props.preUsage.august,
    +props.preUsage.september,
    +props.preUsage.october,
    +props.preUsage.november,
    +props.preUsage.december,
  ];

  let newBill = [];
  for (let i = 0; i <= production.length - 1; i++) {
    newBill.push(usage[i] - production[i]);
  }

  const total = (arr) => arr.reduce((a, b) => a + b);

  useEffect(() => {
    if (billCalc[2] * nestMax < 2076) {
      return setNestAmount(billCalc[2] * nestMax);
    }
    setNestAmount(2076);
  }, [production, nestMax, nest]);

  useEffect(() => {
    if (nest === 0) {
      setNestAdder(0);
    }
    if (utilityLocation === "Virginia") {
      setNestAdder(1);
    }
  }, [nest, utilityLocation]);

  useEffect(() => {
    if (props.customer.state === "Ohio") {
      setHasRec(1);
    }
    if (props.utility === "Salt River Project (SRP)") {
      setLoadSwitch(1);
    }
  }, [utilityLocation, props.utility]);

  useEffect(() => {
    setTotalProduction(total(production));
  }, [production]);

  let totalUsage = total(usage);

  let custUtility = props.utility;
  let billCalc;
  let postBill;

  if (rateOverRide === 0) {
    switch (custUtility) {
      case "PNM - Public Service Company of New Mexico":
      case "Continental Divide Electric":
      case "CNM":
        billCalc = PNMCalc(usage);
        postBill = PNMCalc(newBill);
        break;
      case "Black Hills Electric":
        billCalc = BlackHillsCalc(usage);
        postBill = BlackHillsCalc(newBill);
        break;
      default:
        billCalc = MasterCalc(usage, calcs);
        postBill = MasterCalc(newBill, calcs);
    }
  } else {
    billCalc = OverRideCalc(usage, rateOverRideAmount);
    postBill = OverRideCalc(newBill, rateOverRideAmount);
  }

  useEffect(() => {
    if (
      custUtility === "City Public Service (CPS)" ||
      custUtility === "Colorado Springs Utilities" ||
      custUtility === "Fort Collins Utilities (FCU)"
    ) {
      setRebateSF(rebate);
    }
  }, [rebate, custUtility]);

  useEffect(() => {
    let pu = 0;
    let sd = 0;
    let ref = 0;
    if (sameDay === 1) {
      sd = +sameDayAmount;
    }
    if (preferredUtility === 1) {
      pu = +preferredUtilityAmount;
    }
    if (referral === 1) {
      ref = +referralAmount;
    }
    if (
      custUtility === "Austin Energy" ||
      custUtility.includes("Xcel Energy") ||
      custUtility === "Ameren Illinois" ||
      custUtility === "Commonwealth Edison (ComEd)" ||
      custUtility === "Salem Electric"
    ) {
      return setLoanAmount(
        Math.ceil(systemCost - downPayment - sd - ref - systemSize * pu),
      );
    }
    return setLoanAmount(
      Math.ceil(systemCost - rebate - downPayment - sd - ref - systemSize * pu),
    );
  }, [custUtility, systemCost, downPayment, rebateOverride, rebate]);
  // console.log(loanAmount)
  useEffect(() => {
    setSystemSize(panelAmount * mod[3]);
  }, [panelAmount, mod]);

  useEffect(() => {
    // When panelAmount is set, update maxModCount to match
    if (panelAmount) {
      setMaxModCount(panelAmount);
    }
  }, [panelAmount]);

  useEffect(() => {
    // setSystemSizeAC(
    //   (props.currentProp.panelAmount * ((mod[4] * inverter[3]) / 1000)).toFixed(
    //     2
    //   )
    // );
    setSystemSizeAC(6);
  }, [panelAmount, mod, inverter]);

  useEffect(() => {
    if (costOverRide) {
      const newPpw = (+costOverRide - adderTotal) / +systemSize;
      return setPropPpw(newPpw);
    }
    if (overRide) {
      return setPropPpw(basePpw);
    }
    if (utilityLocation === "Texas") {
      return setPropPpw(+ppw);
    }
    return setPropPpw(+ppw);
  }, [systemCost, overRide, basePpw, props, costOverRide, systemSize]);

  useEffect(() => {
    // if (nest > 0) {
    //   return setPropRatio(Math.round((totalProduction - nestAmount) / (systemSize / 1000)))
    // }
    setPropRatio(totalProduction / (systemSize / 1000));
  }, [systemSize, totalProduction]);

  useEffect(() => {
    return setIonRebate(+hasAdder);
  }, [props.rebate.hasAdder]);

  const { stateInfo } = props;

  useEffect(() => {
    if (+stateInfo.stateTax === 1) {
      if (stateInfo.taxType === "Fixed") {
        setStateTax(+stateInfo.taxFixed);
      }
      if (stateInfo.taxType === "Percentage") {
        let tax = (systemCost - homeEnergyTotal) * +stateInfo.taxPerWatt;
        if (tax >= +stateInfo.taxMax) {
          return setStateTax(+stateInfo.taxMax);
        }
        setStateTax(tax);
      }
      if (stateInfo.taxType === "Per Watt") {
        let tax = systemSize * +stateInfo.taxPerWatt;
        if (tax >= +stateInfo.taxMax) {
          return setStateTax(+stateInfo.taxMax);
        }
        setStateTax(tax);
      }
    }
    if (custUtility.includes("Xcel Energy")) {
      if (powerWall && props.customer.state !== "Colorado") {
        return setStateTax(1000);
      }
      setStateTax(0);
    }
  }, [stateInfo, panelAmount, systemCost, systemSize, powerWall]);

  useEffect(() => {
    if (partialRebate === 1) {
      return setPartialPanels(+partialPanels);
    }
    setPartialPanels(+panelAmount);
  }, [partialRebate, partialPanels, panelAmount]);

  useEffect(() => {
    if (partialPanels < 1) {
      setHasRebate(0);
    } else {
      setHasRebate(+props.rebate.hasRebate);
    }
  }, [props.rebate.hasRebate, partialRebate, partialPanels]);

  useEffect(() => {
    if (+rebateOverride !== 1) {
      if (+hasRebate > 1) {
        return setRebateOverride(+hasRebate);
      }
      setRebateOverride(0);
    }
  }, [hasRebate]);

  useEffect(() => {
    // The Xcel Renewable Battery Connect Program:
    // We only do Tesla batteries (in 2025) and they will always max out the rebate to 5000
    if (custUtility.includes("Xcel Energy") && powerWall > 0 && props.customer.state !== "Colorado") {
      let xcelRebateMax = 5000;
      return setRebate(xcelRebateMax);
    }
    if (+rebateOverride === 1) {
      setRebate(rebateOverrideAmt);
    } else if (+hasRebate > 0) {
      if (+rebateOverride === 1) {
        return setRebate(0);
      }
      let oregonDc = 0;
      let oregonMax = 5000;
      let rMax = +rebateMax;
      let perWatt = +rebatePerWatt;
      if (+hasRebate > 1) {
        rMax = oregonMax;
      }
      if (+hasRebate === 2) {
        perWatt = 1.8;
      }
      if (+hasRebate === 3) {
        perWatt = 0.2;
      }
      if (+hasRebate === 4) {
        perWatt = 1.8;
      }
      if (+hasRebate === 5) {
        perWatt = 1.8 + +rebatePerWatt;
        rMax = +oregonMax + +rebateMax;
      }
      let ac = 0;
      if (rebateType === "Per Watt A/C") {
        ac = partialPanels * mod[4] * inverter[3] * perWatt;
      }
      let dc = 0;
      if (rebateType === "Per Watt D/C") {
        dc = partialPanels * mod[3] * perWatt;
      }
      let fixed = 0;
      if (rebateType === "Fixed") {
        fixed = rebateFixed;
      }
      let totalRebate = ac + dc + fixed;

      if (rebateMax || rMax) {
        if (totalRebate >= +rMax) {
          return setRebate(Math.round(+rMax));
        }
        return setRebate(Math.round(+totalRebate));
      }
      return setRebate(Math.round(+totalRebate));
    }
    return setRebate(rebateOverrideAmt);
  }, [
    systemSize,
    mod,
    production,
    panelAmount,
    rebateOverride,
    rebate,
    overRide,
    rebateOverride,
    rebateOverrideAmt,
    partialRebate,
    partialPanels,
    hasRebate,
    powerWall,
  ]);

  useEffect(() => {
    if (custUtility === "Austin Energy") {
      if (
        panelAmount * mod[4] * inverter[3] < 3000 &&
        total(production) / total(usage) < 0.75
      ) {
        return setRebate(0);
      }
    }
  }, [systemSize, mod, production, panelAmount]);

  let militaryAmount =
    +military === 1 || +military === 3 ? 250 / +dealerFee : 500 / +dealerFee;

  useEffect(() => {
    if (+powerWall === 1 && clone !== 1) {
      setInverter(["12", "Tesla", "Powerwall 3", 97.5]);
    }
  }, [powerWall, battery10, powerWallAmount]);

  useEffect(() => {
    setDealerFee(+loanA[9]);
  }, [loanA]);

  const switchDealerFee = (amount, previousDf, currentDf) => {
    return (amount * previousDf) / currentDf;
  };

  useEffect(() => {
    if (clone === 1) {
      setTreeRemovalAmount(treeRemovalAmount, previousDealerFee, dealerFee);
      setBattery10Amount(battery10Amount, previousDealerFee, dealerFee);
      setExpansionPackAmount(expansionPackAmount, previousDealerFee, dealerFee);
      setReRoofAmount(reRoofAmount, previousDealerFee, dealerFee);
      setClone(0);
    } else {
      setTreeRemovalAmount(
        switchDealerFee(treeRemovalAmount, previousDealerFee, dealerFee),
      );
      setBattery10Amount(
        switchDealerFee(battery10Amount, previousDealerFee, dealerFee),
      );
      setExpansionPackAmount(
        switchDealerFee(expansionPackAmount, previousDealerFee, dealerFee),
      );
      setReRoofAmount(
        switchDealerFee(reRoofAmount, previousDealerFee, dealerFee),
      );
    }

    setLoadSwitchAmount(1500 / +dealerFee);
    setUtilityReviewAmount(1250 / +dealerFee);
    setTravelAmount(0.1 / +dealerFee);
    setBallastAmount(0.23 / +dealerFee);
    setPSolarAmount(roundAndFormatNumber(0.15 / +dealerFee, 4));
    setMspAmount(3500 / +dealerFee);
    setNewMspAmount(3500 / +dealerFee);
    setCritterGuardAmount(0.1 / +dealerFee);
    setPvSystemAddOnAmount(1000 / +dealerFee);

    setAdderAmount(500 / +dealerFee);
    setBlkAdderAmount(500 / +dealerFee);

    setPreviousDealerFee(dealerFee);
  }, [dealerFee, clone]);

  // // Ask christopher on this
  // const tierCashAdderAmount = () => {
  //   let tierAdderAmount = 300;
  //   if (+dealerFee === 1) {
  //     tierAdderAmount = 0;
  //   } else if (+dealerFee < 1 && +dealerFee > 0.7) {
  //     tierAdderAmount = 150;
  //   }
  //   return tierAdderAmount;
  // };

  useEffect(() => {
    let md = 0;
    if (+military > 0) {
      md = +militaryAmount;
    }
    let tb = 0;
    if (nest > 0) {
      tb = +nestCost;
    }
    let th = 0;
    if (townhome === 1) {
      th = +townhomeAmount;
    }
    let tt = 0;
    if (treeRemoval === 1) {
      tt = +treeRemovalAmount;
    }
    let rr = 0;
    if (reRoof > 0) {
      rr = +reRoofAmount;
    }
    let sh = 0;
    if (smartHome === 1) {
      sh = +smartHomeAmount;
    }
    let hv = 0;
    if (hvac === 1) {
      hv = +hvacAmount;
    }
    let ld = 0;
    if (led === 1) {
      ld = +ledAmount;
    }
    let trf = 0;
    if (turf === 1) {
      trf = +turfAmount;
    }
    let wdw = 0;
    if (windows === 1) {
      wdw = +windowsAmount;
    }
    let wtr = 0;
    if (water === 1) {
      wtr = +waterAmount;
    }
    let bal = 0;
    if (ballast === 1) {
      bal = +ballastTotal;
    }
    let gm = 0;
    if (groundMount === 1) {
      gm = +groundMountTotal;
    }
    let ps = 0;
    if (pSolar === 1) {
      ps = +pSolarAmount;
    }
    let adder = 0;
    if (ionRebate > 0) {
      adder = +adderAmount;
    }
    let blk = 0;
    if (blkAdder === 1 || blkAdder === 2) {
      blk = +blkAdderAmount;
    }
    let pb = 0;
    if (panelBonus === 1 || panelBonus === 2) {
      pb = +panelBonusAmount;
    }
    let ms = 0;
    if (msp === 1) {
      ms = +mspAmount;
    }
    if (msp === 2) {
      ms = +newMspAmount;
    }
    let cg = 0;
    if (critterGuard === 1) {
      cg = +critterGuardAmount;
    }
    let b3 = 0;
    if (battery3 === 1) {
      b3 = +battery3Amount;
    }
    let b10 = 0;
    if (battery10 >= 11 && battery10 < 20) {
      const basePricing =
        props.customer.state === "Texas" ||
        props.customer.state === "Illinois"
          ? battery10Amount
          : getPowerWallOptions(props.customer.state)[0].value;
      const additionalBatteryAmount = basePricing / +dealerFee;
      b10 = Math.floor(
        battery10Amount + additionalBatteryAmount * (battery10 - 11),
      );
    }
    if (battery10 > 20 && battery10 < 31) {
      const additionalBatteryAmount =
        getEnphase10cAdditionalBatteryAmount(props.customer.state) / +dealerFee;
      b10 = +battery10Amount + additionalBatteryAmount * (battery10 - 21);
      // b10 = +battery10Amount;
    }
    let b10add = 0;
    if (battery10 > 1 && battery10 < 11) {
      b10add = +addBattery10Amount * (battery10 - 1);
    }
    // using sustainable as portland $.34 adder
    let sus = 0;
    if (sustainable === 1) {
      sus = 0.34;
    }
    let ls = 0;
    if (loadSwitch === 1) {
      ls = +loadSwitchAmount;
    }
    let ut_rvw = 0;
    if (!!utilityReview) {
      ut_rvw = +utilityReviewAmount;
    }
    let ta = 0;
    if (travelAdder) {
      ta = +travelAdderAmount;
    }
    let ep = 0;
    if (expansionPack && battery10 >= 11 && battery10 < 20) {
      ep = +expansionPackAmount * expansionPack;
    }
    let pvo = 0;
    if (pvSystemAddOn === 1) {
      pvo = +pvSystemAddOnAmount;
    }
    let ac = 0;
    if (acCoupled) {
      ac = +acCoupledAmount;
    }
    let pa = 0;
    if (permittingAdder > 0) {
      pa = permittingAdderAmount * systemSize;
    }
    let ws = 0;
    if (waterSoftener === 1) {
      ws = +waterSoftenerAmount;
    }
    // ac +
    return setAdderTotal(
      Math.round(
        (ps + cg + sus) * systemSize +
          adder +
          blk +
          pb +
          ms +
          gm +
          bal +
          b3 +
          b10 +
          b10add +
          tt +
          th +
          tb +
          md +
          rr +
          sh +
          hv +
          ld +
          trf +
          wdw +
          wtr +
          ls +
          ut_rvw +
          ta +
          smallSystemAdderAmount +
          ep +
          pvo +
          ac +
          pa +
          ws,
      ),
    );
  }, [
    treeRemoval,
    treeRemovalAmount,
    reRoof,
    reRoofAmount,
    smartHome,
    smartHomeAmount,
    hvac,
    hvacAmount,
    led,
    ledAmount,
    turf,
    turfAmount,
    windows,
    windowsAmount,
    water,
    waterAmount,
    ballast,
    ballastAmount,
    ionRebate,
    ionRebate2,
    groundMount,
    groundMountAmount,
    groundMountPanels,
    groundMountTotal,
    pSolar,
    pSolarAmount,
    msp,
    mspAmount,
    newMspAmount,
    critterGuard,
    critterGuardAmount,
    overRide,
    systemSize,
    basePpw,
    ppw,
    panelAmount,
    smallSystemAdderAmount,
    travel,
    travelAmount,
    adderTotal,
    arrayCount,
    costOverRide,
    ballastPanels,
    partialBallast,
    ballastTotal,
    rebateOverride,
    battery3,
    battery10,
    battery10Amount,
    sameDay,
    preferredUtility,
    referral,
    nestAdder,
    nest,
    blkAdder,
    rebateOverride,
    rebateOverrideAmt,
    sustainable,
    city,
    loadSwitch,
    panelBonus,
    townhome,
    military,
    powerWall,
    powerWallAmount,
    battery10Amount,
    utilityReview,
    utilityReviewAmount,
    dealerFee,
    expansionPack,
    battery10,
    pvSystemAddOn,
    pvSystemAddOnAmount,
    nestCost,
    permittingAdder,
    permittingAdderAmount,
    waterSoftener,
    waterSoftenerAmount,
  ]);

  let homeEnergyTotal =
    +smartHomeAmount +
    +hvacAmount +
    +ledAmount +
    +turfAmount +
    +windowsAmount +
    +waterAmount;

  useEffect(() => {
    let overPerWatt = +cashPpw;
    return setCash(+overPerWatt * systemSize + adderTotal - rebateSF);
  }, [
    ballast,
    ionRebate,
    ionRebate2,
    groundMount,
    pSolar,
    msp,
    critterGuard,
    permittingAdder,
    permittingAdderAmount,
    overRide,
    systemSize,
    basePpw,
    ppw,
    panelAmount,
    travel,
    adderTotal,
    arrayCount,
    ballastPanels,
    partialBallast,
    ballastTotal,
    battery10,
    battery3,
    preferredUtility,
    sameDay,
    referral,
    nestAdder,
    blkAdder,
    rebateSF,
    sustainable,
    utilityReview,
    pvSystemAddOn,
  ]);

  let cashPpwDisplay = (cash / systemSize).toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
  });

  if (panelAmount < 1) {
    cashPpwDisplay = "$0";
  }

  useEffect(() => {
    if (panelAmount && panelAmount <= 9) {
      // is a small system
      setSmallSystemAdder(true);
      if (panelAmount <= 5) {
        // too small / 5 and under panels
        Alert.error("Minimum panel count is 6.", {
          position: "top-right",
          effect: "flip",
          beep: false,
          timeout: 5000,
          offset: 100,
          color: "rgba(255, 255, 255, 0.927)",
        });
        setSmallSystemAdderAmount(2000 / dealerFee);
      } else {
        if (panelAmount <= 7) {
          // 6 or 7 panels
          setSmallSystemAdderAmount(1000 / dealerFee);
        } else {
          // 8 or 9 panels
          setSmallSystemAdderAmount(500 / dealerFee);
        }
      }
    } else {
      setSmallSystemAdder(false);
      setSmallSystemAdderAmount(0);
    }
  }, [panelAmount, dealerFee]);

  useEffect(() => {
    let pu = 0;
    if (preferredUtility === 1) {
      pu = +preferredUtilityAmount;
    }
    let ref = 0;
    if (referral === 1) {
      ref = +referralAmount;
    }
    let sd = 0;
    if (sameDay === 1) {
      sd = +sameDayAmount;
    }
    if (overRide === true && costOverRide === "") {
      let overPerWatt = +basePpw;
      return setSystemCost(
        Math.ceil((+overPerWatt + pu) * systemSize + adderTotal + ref + sd),
      );
    }
    if (overRide === true && basePpw === "") {
      return setSystemCost(
        Math.ceil(+costOverRide + ref + sd + pu * systemSize),
      );
    }
    if (overRide === false) {
      let perWatt = +ppw;
      return setSystemCost(
        Math.ceil((+perWatt + pu) * systemSize + adderTotal + ref + sd),
      );
    }
  }, [
    ballast,
    ionRebate,
    ionRebate2,
    blkAdder,
    groundMount,
    groundMountPanels,
    groundMountTotal,
    pSolar,
    msp,
    critterGuard,
    permittingAdder,
    permittingAdderAmount,
    overRide,
    systemSize,
    basePpw,
    ppw,
    panelAmount,
    travel,
    adderTotal,
    arrayCount,
    costOverRide,
    ballastPanels,
    partialBallast,
    ballastTotal,
    rebateOverride,
    battery3,
    battery10,
    sameDay,
    preferredUtility,
    referral,
    nestAdder,
    blkAdder,
    rebateOverride,
    rebateOverrideAmt,
    sustainable,
    utilityReview,
    pvSystemAddOn,
  ]);

  // console.log(custUtility)
  useEffect(() => {
    if (costOverRide && overRide) {
      return setSystemCostOverRide(1);
    }
    if (costOverRide === "" || !overRide) {
      return setSystemCostOverRide(0);
    }
  }, [costOverRide, overRide, rebate]);

  const [adderMax, setAdderMax] = useState("");

  useEffect(() => {
    setAdderMax(Math.round(+loanAmount / 2));
  }, [
    costOverRide,
    overRide,
    basePpw,
    systemSize,
    systemCost,
    adderTotal,
    loanAmount,
  ]);

  const twentyFiveYear = (total, years, ratePercent) => {
    let interestRate = ratePercent / 100 + 1;
    return (total * Math.pow(interestRate, years)).toFixed(2);
  };

  //
  //loan[0] = loanId
  //loan[1] = loanName
  //loan[2] = term
  //loan[3] = interest
  //loan[4] = prePayment
  //loan[5] = postPayment
  //loan[6] = intOnlyPayment
  //loan[7] = itc %

  useEffect(() => {
    let price = ppw;
    if (overRide === true) {
      price = +basePpw;
    }
    setPanelEstimate(
      Math.round((+billCalc[1] / +loanA[4] - adderTotal) / +price / +modSize),
    );
  }, [
    billCalc,
    loanA,
    overRide,
    basePpw,
    ballast,
    ionRebate,
    ionRebate2,
    blkAdder,
    groundMount,
    pSolar,
    msp,
    critterGuard,
    permittingAdder,
    permittingAdderAmount,
    overRide,
    systemSize,
    basePpw,
    panelAmount,
    travel,
    adderTotal,
    ballastTotal,
    referral,
    nestAdder,
    blkAdder,
    groundMountTotal,
    utilityReview,
    pvSystemAddOn,
  ]);

  let firstTerm = 20;
  if (+loanA[2] === 25) {
    firstTerm = 25;
  }

  let loan1Bills = [];

  if (+loanA[6] > 0) {
    loan1Bills = new Array(+loanA[2] - 1).fill(
      +(loanA[4] * loanAmount).toFixed(2),
    );
    loan1Bills.unshift(+(loanA[6] * loanAmount).toFixed(2));
  } else if (loanA[1] === "Flic") {
    loan1Bills = new Array(+loanA[2] - 2).fill(
      +(loanA[5] * loanAmount).toFixed(2),
    );
    loan1Bills.unshift(0, 0);
  } else {
    loan1Bills = new Array(firstTerm).fill(+(loanA[4] * loanAmount).toFixed(2));
  }

  let secondTerm = 12;
  if (+loanB[2] > 0) {
    secondTerm = +loanB[2];
  }

  let loan2Bills = [];
  if (loanB[6] > 0) {
    loan2Bills = new Array(+term2).fill(+(loanB[4] * loanAmount).toFixed(2));
    loan2Bills.unshift(+(loanB[6] * loanAmount).toFixed(2));
  } else {
    loan2Bills = new Array(secondTerm).fill(
      +(loanB[4] * loanAmount).toFixed(2),
    );
  }

  let increase = +stateInfo.utilityEscalator;
  if (custUtility === "Austin Energy") {
    increase = 2;
  }

  let years = [];
  if (usage) {
    for (let i = 0; i <= 29; i++) {
      years.push(+twentyFiveYear(+billCalc[1], i, increase));
    }
  } else {
    years.push(0);
  }

  let postYears = [];
  if (janProduction) {
    for (let i = 0; i <= 29; i++) {
      postYears.push(+twentyFiveYear(+postBill[1], i, increase));
    }
  } else {
    postYears.push(0);
  }

  let postYears1 = [];

  if (postBill) {
    for (let i = 0; i <= 29; i++) {
      postYears1.push(+twentyFiveYear(35, i, increase));
    }
  } else {
    postYears1.push(0);
  }

  let saving = [];
  let savings = [];
  let years1 = [];
  let save = [];

  const savingsCalc = (arr) => {
    postYears.slice(0, arr.length);
    years1 = postYears.slice(-(30 - arr.length), 30);
    for (let i = 0; i < arr.length; i++) {
      saving.push(postYears[i] + arr[i]);
    }
    save = saving.concat(years1);
    for (let i = 0; i <= years.length - 1; i++) {
      savings.push(years[i] - save[i]);
    }
    savings = savings.map((x) => x * 12);
    return total(savings);
  };

  let saving1 = [];
  let savings1 = [];
  let years11 = [];
  let save1 = [];

  const savingsCalc1 = (arr) => {
    postYears.slice(0, arr.length);
    years11 = postYears.slice(-(30 - arr.length), 30);
    for (let i = 0; i < arr.length; i++) {
      saving1.push(postYears[i] + arr[i]);
    }
    save1 = saving1.concat(years11);
    for (let i = 0; i <= years.length - 1; i++) {
      savings1.push(years[i] - save1[i]);
    }
    savings1 = savings1.map((x) => x * 12);
    return total(savings1);
  };

  let recValue = {
    afterEnergy: 0,
    capacityFactor: 0,
    numRecs: 0,
    acSystem: 0,
    additionalCollateral: 0,
    utilityCollateral: 0,
    applicationFee: 0,
    grossValue: 0,
    product: 0,
  };

  if (["Illinois", "Virginia", "Ohio"].includes(props.customer.state)) {
    recValue = RECCalc(
      panelAmount,
      mod,
      invRating,
      totalProduction,
      props.customer.state,
      loanA[1],
      hasRec,
      custUtility,
    );
  }

  const prePayment = () => {
    let tax = stateTax;
    if (utilityLocation === "South Carolina") {
      tax = 3500;
    }
    if (+recValue.afterEnergy > 0) {
      tax = recValue.totalPostFeesAndBonds;
    }
    if (
      (stateTax || recValue.totalPostFeesAndBonds) &&
      loanA[1] === "Dividend"
    ) {
      if (loanA[6] > 0) {
        let a = loanA[3] / 100 / 12;
        let b = a + 1;
        let c = loanA[2] * 12 - 16;
        let d = Math.pow(b, -c);
        let e = 1 - d;
        let f = a / e;
        let g = f * (loanAmount * +dealerFee - tax); // This isn't dealer fee is it?

        return Math.round(g);
      }
      let a = loanA[3] / 100 / 12;
      let b = a + 1;
      let c = loanA[2] * 12 - 6;
      let d = Math.pow(b, -c);
      let e = 1 - d;
      let f = a / e;
      let g = f * (loanAmount * +dealerFee - tax);

      return Math.round(g);
    }
    if (
      (stateTax || recValue.totalPostFeesAndBonds) &&
      loanA[1] === "Sunlight"
    ) {
      let a = loanA[3] / 100 / 12;
      let b = a + 1;
      let c = loanA[2] * 12 - 6;
      let d = Math.pow(b, -c);
      let e = 1 - d;
      let f = a / e;
      let g = f * (loanAmount * +dealerFee - tax);

      return Math.round(g);
    }
    if (
      (stateTax || recValue.totalPostFeesAndBonds) &&
      loanA[1] === "GoodLeap"
    ) {
      let a = loanA[3] / 100 / 12;
      let b = a + 1;
      let c = loanA[2] * 12 - 6;
      let d = Math.pow(b, -c);
      let e = 1 - d;
      let f = a / e;
      let g = f * (loanAmount * +dealerFee - tax);

      return Math.round(g);
    }
    return Math.round(loanA[4] * loanAmount);
  };

  const gallons = () => {
    let one = +totalProduction * -0.000689551;
    if (nest > 0) {
      one = (+totalProduction - +nestAmount) * -0.000689551;
    }
    let two = -one;
    let three = two * 1.10231;
    let four = three * 67629;
    return Math.round(four / 30);
  };

  const homes = () => {
    let one = totalProduction * 30;
    if (nest > 0) {
      one = (totalProduction - nestAmount) * 30;
    }
    return Math.round(one / 10000);
  };

  const garbages = () => {
    let one = totalProduction * -0.000689551;
    if (nest > 0) {
      one = (totalProduction - nestAmount) * -0.000689551;
    }
    let two = -one;
    let three = two * 1.10231;
    let four = three * 36;
    return Math.round(four);
  };

  const trees = () => {
    let one = totalProduction * -0.000689551;
    if (nest > 0) {
      one = (totalProduction - nestAmount) * -0.000689551;
    }
    let two = -one;
    let three = two * 1.10231;
    let four = three * 798;
    return Math.round(four);
  };

  // Page 2
  const cost25yr = Math.round(total(years) * 12);
  const currAnnBill = Math.round(years[0] * 12);
  const today = Math.round(years[0]);
  const yr5 = Math.round(years[4]);
  const yr10 = Math.round(years[9]);
  const yr15 = Math.round(years[14]);
  const yr20 = Math.round(years[19]);
  const yr25 = Math.round(years[24]);
  const yr30 = Math.round(years[29]);
  const gallon = gallons();
  const home = homes();
  const garbage = garbages();
  const tree = trees();

  // Page 5
  // displayProd
  let nestImpact = "-";
  // let nestImpact = Math.round(nestAmount / totalUsage * 100)
  if (nest === 0) {
    nestImpact = "-";
  }
  let utilityPower = Math.round(100 - (totalProduction / totalUsage) * 100);
  if (utilityPower < 0) {
    utilityPower = 0;
  }
  let solarPower = Math.round((totalProduction / totalUsage) * 100);
  let janU = Math.round(usage[0]);
  let febU = Math.round(usage[1]);
  let marU = Math.round(usage[2]);
  let aprU = Math.round(usage[3]);
  let mayU = Math.round(usage[4]);
  let junU = Math.round(usage[5]);
  let julyU = Math.round(usage[6]);
  let augU = Math.round(usage[7]);
  let sepU = Math.round(usage[8]);
  let octU = Math.round(usage[9]);
  let novU = Math.round(usage[10]);
  let decU = Math.round(usage[11]);
  let janP = Math.round(production[0]);
  let febP = Math.round(production[1]);
  let marP = Math.round(production[2]);
  let aprP = Math.round(production[3]);
  let mayP = Math.round(production[4]);
  let junP = Math.round(production[5]);
  let julyP = Math.round(production[6]);
  let augP = Math.round(production[7]);
  let sepP = Math.round(production[8]);
  let octP = Math.round(production[9]);
  let novP = Math.round(production[10]);
  let decP = Math.round(production[11]);

  // Page 6
  const pmt1 = prePayment();
  const pmt2 = Math.round(loanAmount * loanA[5]);
  const pmt3 = Math.round(loanAmount * loanA[6]);
  // stateTax
  const [netCost, setNetCost] = useState(0);

  useEffect(() => {
    let newNetCost = Math.round(
      +loanAmount +
        +downPayment -
        (+loanAmount + +downPayment - homeEnergyTotal) * loanA[7] -
        stateTax -
        (recValue?.afterEnergy || 0),
    );

    if (
      custUtility === "Austin Energy" ||
      powerWall ||
      custUtility === "Ameren Illinois" ||
      custUtility === "Commonwealth Edison (ComEd)"
    ) {
      newNetCost = Math.round(
        +loanAmount -
          +rebate +
          +downPayment -
          (+loanAmount + +downPayment - homeEnergyTotal) * loanA[7] -
          stateTax -
          (recValue?.afterEnergy || 0),
      );
    }

    setNetCost(newNetCost);
  }, [
    loanAmount,
    downPayment,
    homeEnergyTotal,
    loanA,
    stateTax,
    recValue,
    custUtility,
    rebate,
  ]);

  const itcTotal = (loanAmount + +downPayment - homeEnergyTotal) * loanA[7];
  const allIncentives = Math.round(itcTotal + stateTax + recValue.afterEnergy);
  let avg25Utility;
  let avg25_1;
  let avg25_2;
  let ionCostA;
  let ionCostB;
  if (loanA) {
    avg25Utility = ((total(years) * 12) / 30 / totalUsage).toFixed(2);
    avg25_1 = ((total(loan1Bills) * 12) / 30 / totalProduction).toFixed(2);
    avg25_2 = ((total(loan2Bills) * 12) / 30 / totalProduction).toFixed(2);
    ionCostA = Math.round(total(loan1Bills) * 12);
    ionCostB = Math.round(total(loan2Bills) * 12);
  }

  // Page 7
  const pmt1B = Math.round(loanAmount * loanB[4]);
  const pmt2B = Math.round(loanAmount * loanB[5]);
  const loan1Savings = Math.round(savingsCalc(loan1Bills));
  const loan2Savings = Math.round(savingsCalc1(loan2Bills));
  let remainingCost = Math.round(total(postYears) * 12);
  if (remainingCost <= 0) {
    remainingCost = Math.round(total(postYears1));
  }

  // Page 8
  const currentPerKw = (billCalc[1] / billCalc[4]).toFixed(3);

  let mappedLoans = loanProducts.map((loans, i) => {
    // console.log(loans.loanTerm)
    let info = [
      +loans.loanId,
      loans.loanName,
      +loans.loanTerm,
      +loans.loanInterest,
      +loans.prePayment,
      +loans.postPayment,
      +loans.interestOnlyPayment,
      +loans.itc,
      +loans.specialPrice,
      +loans.dealerFee,
    ];
    return (
      <option key={i} value={info}>
        {" "}
        {loans.loanName.replace("Owner Financing", "Cash")}{" "}
        {+loans.loanId === 115
          ? null
          : +loans.isPpa === 1
            ? `$${loans.ppaRate} ${(+loans.ppaEscalator * 100).toFixed(2)}%`
            : `${+loans.loanTerm} YR ${+loans.loanInterest}%`}
      </option>
    );
  });

  let mappedModules = (Array.isArray(modules) ? modules : []).map((mod, i) => {
    let info = [mod.modId, mod.make, mod.model, mod.size, mod.ptcRating];
    // console.log(info, modules)
    return (
      <option key={i} value={info}>
        {" "}
        {`${mod.make} ${mod.model} ${mod.size}`}
      </option>
    );
  });

  let mappedInverters = (Array.isArray(inverters) ? inverters : []).map((inv, i) => {
    let info = [inv.invId, inv.make, inv.model, inv.effRating];
    // console.log(info, modules)
    return (
      <option key={i} value={info}>
        {" "}
        {`${inv.make} ${inv.model}`}
      </option>
    );
  });

  //loan[0] = loanId
  //loan[1] = loanName
  //loan[2] = term
  //loan[3] = interest
  //loan[4] = prePayment
  //loan[5] = postPayment
  //loan[6] = intOnlyPayment
  //loan[7] = itc %
  //loan[8] = special pricing

  useEffect(() => {
    if (clone !== 1) {
      if (loanChangeSize > 0) {
        if (systemSize >= +loanChangeSize) {
          setLoanA([
            +id3,
            loan3,
            +term3,
            +int3,
            +pre3,
            +post3,
            +interest3,
            +itc3,
            +specialPrice3,
            +dealerfee3,
          ]);
          setPpw(+props.ppw + +loanChangeIncrease);
        } else {
          return (
            setLoanA([
              +id1,
              loan1,
              +term1,
              +int1,
              +pre1,
              +post1,
              +interest1,
              +itc1,
              +specialPrice1,
              +dealerfee1,
            ]),
            setPpw(+props.ppw)
          );
        }
      }
    }
  }, [systemSize, loanChangeSize]);

  useEffect(() => {
    if (clone !== 1) {
      if (
        +loanA[8] > 0 &&
        salesTeam !== "Las Vegas Sales Team II" &&
        +specialLoanIncrease === 1
      ) {
        if (+loanA[8] < 1) {
          return setPpw(+props.ppw + +loanA[8]);
        }
        if (+loanA[8] > 1) {
          return setPpw(+loanA[8]);
        }
      }
      setPpw(+props.ppw);
      if (
        salesTeam === "Las Vegas Sales Team II" ||
        salesTeam === "Las Vegas Sales Team 3"
      ) {
        if (loanA[8] > 0) {
          return setPpw(+props.ppw + 0.2);
        }
        setPpw(+props.ppw);
      }
      if (
        +loanB[8] > 0 &&
        salesTeam !== "Las Vegas Sales Team II" &&
        +specialLoanIncrease === 1
      ) {
        if (+loanB[8] < 1) {
          return setPpw(+props.ppw + +loanB[8]);
        }
        if (+loanB[8] > 1) {
          return setPpw(+loanB[8]);
        }
      }
      setPpw(+props.ppw);
      if (
        salesTeam === "Las Vegas Sales Team II" ||
        salesTeam === "Las Vegas Sales Team 3"
      ) {
        if (loanB[8] > 0) {
          return setPpw(+props.ppw + 0.2);
        }
        setPpw(+props.ppw);
      }
    }
  }, [loanA, loanB]);

  // useEffect(() => {
  //   if (clone !== 1) {
  //     if (loanA[8] > 0 && salesTeam !== 'Las Vegas Sales Team II' && +specialLoanIncrease === 1) {
  //       return setPpw(loanA[8])
  //     }
  //     if (salesTeam === 'Las Vegas Sales Team II' || salesTeam === 'Las Vegas Sales Team 3') {
  //       if (loanA[8] > 0) {
  //         return setPpw(+props.ppw + .20)
  //       } setPpw(+props.ppw)
  //     }
  //   }
  // }, [loanA])

  const stateTaxPayment = () => {
    if (
      stateTax ||
      custUtility === "Austin Energy" ||
      custUtility === "Salem Electric"
    ) {
      return (
        <p className="mb-0">
          <b>ITC & Local Incentives Applied:</b> $
          {panelAmount ? prePayment() : "0"}
        </p>
      );
    }
  };

  // console.log(props.panelAmount)
  useEffect(() => {
    setPanelAmount(props.panelAmount);
  }, [props.panelAmount]);

  useEffect(() => {
    $(function calculations() {
      //run this on dom ready
      $(".paste-me").on("paste", function (e) {
        //add the paste event to all of the paste-me classes
        var data1 = e.originalEvent.clipboardData.items[0];
        //get the data transfer item of hte original clipboard data event.
        if (data1.kind === "string" && data1.type === "text/plain") {
          //If it is a string and text/plain, move forward
          e.stopPropagation();
          //Stop the propagtion of this event
          data1.getAsString(function (s) {
            //get the string contents of the clipboard item.
            s = s.split("\t").slice(25);
            //split it by spaces
            $(".paste-me").each(function (i, item) {
              //loop through each .paste-me item
              $(item).val(s[i] || "");
              //set the value from the split array, or an empty string if someone copy/pastes something too small to put a value in each item
            });
            // console.log(s)
            setJanProduction(s[0]);
            setFebProduction(s[1]);
            setMarProduction(s[2]);
            setAprProduction(s[3]);
            setMayProduction(s[4]);
            setJunProduction(s[5]);
            setJulyProduction(s[6]);
            setAugProduction(s[7]);
            setSepProduction(s[8]);
            setOctProduction(s[9]);
            setNovProduction(s[10]);
            setDecProduction(s[11]);
          });
        }
      });
    });
  }, [production]);

  let newProduction;

  useEffect(() => {
    newProduction = StateProduction(utilityLocation, annualProduction);
    if (newProduction) {
      setJanProduction(newProduction[0]);
      setFebProduction(newProduction[1]);
      setMarProduction(newProduction[2]);
      setAprProduction(newProduction[3]);
      setMayProduction(newProduction[4]);
      setJunProduction(newProduction[5]);
      setJulyProduction(newProduction[6]);
      setAugProduction(newProduction[7]);
      setSepProduction(newProduction[8]);
      setOctProduction(newProduction[9]);
      setNovProduction(newProduction[10]);
      setDecProduction(newProduction[11]);
    }
  }, [annualProduction]);

  useEffect(() => {
    // if (nest > 0) {
    //   return setDisplayProd(Math.round((+totalProduction - +nestAmount)))
    // }
    return setDisplayProd(Math.round(+totalProduction));
  }, [totalProduction, nest]);

  const handleGetAuroraInfo = async () => {
    setLoadingDesigns(true);
    setShowAuroraDesignModal(true);
    try {
      const res = await auroraApi.getDesignsForProject({
        projectId: props.customer.projectID,
      });
      if (res.success && res.data && res.data.designs) {
        setAuroraDesigns(res.data.designs);
      } else {
        Alert.error("Failed to fetch Aurora designs", {
          position: "top-right",
          effect: "flip",
          beep: false,
          timeout: 5000,
        });
        setShowAuroraDesignModal(false);
      }
    } catch (error) {
      console.error("Error fetching Aurora designs:", error);
      Alert.error("Failed to fetch Aurora designs", {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
      });
      setShowAuroraDesignModal(false);
    } finally {
      setLoadingDesigns(false);
    }
  };

  const getSolarGrafPropInfo = async (designId = null) => {
    setLoading(true);
    try {
      const res = await auroraApi.syncDesign({
        projectId: props.customer.projectID,
        designId: designId,
        should_sync: false, // Don't sync when called from modal, just get info
      });
      const { heatmapImageUrl, panelArraysCount, numPanelArrays, acMonthly } =
        res.data;

      setImg(heatmapImageUrl);
      setPanelAmount(panelArraysCount);
      setArrayCount(numPanelArrays);
      
      // Store the Aurora design ID that was synced
      if (designId) {
        setSyncedAuroraDesignId(designId);
      }

      const monthSetters = [
        setJanProduction,
        setFebProduction,
        setMarProduction,
        setAprProduction,
        setMayProduction,
        setJunProduction,
        setJulyProduction,
        setAugProduction,
        setSepProduction,
        setOctProduction,
        setNovProduction,
        setDecProduction,
      ];

      acMonthly.forEach((value, index) => {
        monthSetters[index](Math.round(value));
      });

      // Refresh customer/usage data so the usage graph updates (e.g. when opened from Dashboard)
      if (props.getCustomer) {
        props.getCustomer();
      }
    } catch (error) {
      console.error("Error in getSolarGrafPropInfo:", error);
      Alert.error("Failed to get Aurora design info", {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
      });
      throw new Error("Failed to get SolarGraf proposal info.");
    } finally {
      setLoading(false);
    }
  };

  const proposal = () => {
    if (props.maximumOverDrive) {
      if (reRoof > 1) {
        addRoofQuote();
      }
      return (createProposal(), setGoConfetti(!goConfetti));
    }
    if (arrayCount < 1) {
      return Alert.error(`Please add how many arrays the system has`, {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
    }
    if (maxModCount < panelAmount) {
      return Alert.error(
        `Please add a max panel amount = or > than the panel amount`,
        {
          position: "top-right",
          effect: "flip",
          beep: false,
          timeout: 5000,
          offset: 100,
          color: "rgba(255, 255, 255, 0.927)",
        },
      );
    }
    if (!decProduction) {
      return Alert.error(`Please add production from Aurora`, {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
    }
    if (maxOffset && props.usageType !== "Square Footage") {
      if ((totalProduction / totalUsage) * 100 >= +maxOffset + 0.5) {
        return Alert.error(`Max offset is ${maxOffset}% in ${custUtility}`, {
          position: "top-right",
          effect: "flip",
          beep: false,
          timeout: 5000,
          offset: 100,
          color: "rgba(255, 255, 255, 0.927)",
        });
      }
    }
    if (maxSystemSize) {
      if (systemSize > +maxSystemSize) {
        return Alert.error(
          `Max system size is ${maxSystemSize / 1000} kW in ${custUtility}`,
          {
            position: "top-right",
            effect: "flip",
            beep: false,
            timeout: 5000,
            offset: 100,
            color: "rgba(255, 255, 255, 0.927)",
          },
        );
      }
      if (maxModCount * mod[3] > +maxSystemSize) {
        return Alert.error(
          `Max system size is ${
            maxSystemSize / 1000
          } kW in ${custUtility}. Max panel count needs to be lowered`,
          {
            position: "top-right",
            effect: "flip",
            beep: false,
            timeout: 5000,
            offset: 100,
            color: "rgba(255, 255, 255, 0.927)",
          },
        );
      }
    }
    if (partialBallast === 1 && ballastPanels > panelAmount) {
      return Alert.error(
        `Cannot have ballast panel amount larger than total panels`,
        {
          position: "top-right",
          effect: "flip",
          beep: false,
          timeout: 5000,
          offset: 100,
          color: "rgba(255, 255, 255, 0.927)",
        },
      );
    }
    if (partialBallast === 1 && ballastPanels < 1) {
      return Alert.error(`Please add amount of ballast panels`, {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
    }
    if (partialGroundMount === 1 && groundMountPanels > panelAmount) {
      return Alert.error(
        `Cannot have ground mount panel amount larger than total panels`,
        {
          position: "top-right",
          effect: "flip",
          beep: false,
          timeout: 5000,
          offset: 100,
          color: "rgba(255, 255, 255, 0.927)",
        },
      );
    }
    if (partialGroundMount === 1 && groundMountPanels < 1) {
      return Alert.error(`Please add amount of ground mount panels`, {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
    }
    if (utilityLocation === "Colorado") {
      if (
        props.usageType === "Square Footage" &&
        totalProduction - nestAmount > props.xcelSqFoot
      ) {
        return Alert.error(
          `Max offset for Colorado sq footage is ${props.xcelSqFoot} for ${props.name}`,
          {
            position: "top-right",
            effect: "flip",
            beep: false,
            timeout: 5000,
            offset: 100,
            color: "rgba(255, 255, 255, 0.927)",
          },
        );
      }
    }
    if (!img) {
      return Alert.error(`Please add a design image to proposal.`, {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
    }
    if (
      !imagery ||
      !storyAmount ||
      !sharedHome ||
      !trenching ||
      !addon ||
      !designLimited ||
      addShadeWaiver === ""
    ) {
      return Alert.error(`Please answer all survey questions.`, {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
    }
    if (adderTotal - battery10Amount * battery10 > adderMax) {
      return Alert.error(
        `Total Adder Amount exceeds 50% of the loan amount. You exceeded the max of ${adderMax.toLocaleString(
          undefined,
          { style: "currency", currency: "USD" },
        )} by ${(adderTotal - adderMax).toLocaleString(undefined, {
          style: "currency",
          currency: "USD",
        })}`,
        {
          position: "top-right",
          effect: "flip",
          beep: false,
          timeout: 5000,
          offset: 100,
          color: "rgba(255, 255, 255, 0.927)",
        },
      );
    }
    if (utilityLocation === "Nevada" && systemCost > 245000) {
      return Alert.error(`Cannot have system cost be over $245,000 in Nevada`, {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
    }
    if (loanA[1] === "Flic" && systemCost > 100000) {
      return Alert.error(`Cannot have system cost be over $100,000 with Flic`, {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
    }
    if (reRoof > 1 && roofSqFt === "") {
      return Alert.error(`Please add the sq footage of the roof`, {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
    }
    if (reRoof > 1 && roofImg === "") {
      return Alert.error(`Please upload the reroofing highlighted image`, {
        position: "top-right",
        effect: "flip",
        beep: false,
        timeout: 5000,
        offset: 100,
        color: "rgba(255, 255, 255, 0.927)",
      });
    }
    if (
      props.customer.roofAge === "15 to 20 years" ||
      props.customer.roofAge === "20+ years"
    ) {
      if (roofSqFt === "") {
        return Alert.error(
          `Roof age > 15 yrs, please fill out roof square footage`,
          {
            position: "top-right",
            effect: "flip",
            beep: false,
            timeout: 5000,
            offset: 100,
            color: "rgba(255, 255, 255, 0.927)",
          },
        );
      }
    }
    if (
      props.customer.territory === null ||
      props.customer.territory === undefined ||
      props.customer.territory === ""
    ) {
      if (
        window.confirm(
          "This address is out of bounds, confirm with boundary map. If good click OK",
        )
      ) {
        return (createProposal(), setGoConfetti(!goConfetti));
      }
      return null;
    }
    if (reRoof > 1) {
      addRoofQuote();
    }
    return (createProposal(), setGoConfetti(!goConfetti));
    // props.setEdit(!props.edit)
  };

  const cancel = () => {
    setAnnualProduction("");
    setJanProduction(0);
    setFebProduction(0);
    setMarProduction(0);
    setAprProduction(0);
    setMayProduction(0);
    setJunProduction(0);
    setJulyProduction(0);
    setAugProduction(0);
    setSepProduction(0);
    setOctProduction(0);
    setNovProduction(0);
    setDecProduction(0);
    setPanelAmount("");
    setMaxModCount("");
    setArrayCount("");
    setDownPayment(0);
    setIonRebate("");
    setBallast(0);
    setGroundMount(0);
    setPSolar(0);
    setMsp(0);
    setCritterGuard(0);
    setPermittingAdder(0);
    setPermittingAdderAmount(0);
    setTravel(0);
    setReRoof(0);
    setRoofSqFt("");
    setRoofType("");
    setSheathing(false);
    setImg("");
    setClone(0);
    setBattery10("");
    setPowerWall("");
    setPreferredUtility("");
    setSameDay("");
    setReferral("");
    setPartialBallast(0);
    setPartialGroundMount(0);
    setSmartHome(0);
    setHvac(0);
    setLed(0);
    setTurf(0);
    setWindows(0);
    setWater(0);
    setSmartHomeAmount(0);
    setHvacAmount(0);
    setLedAmount(0);
    setTurfAmount(0);
    setWindowsAmount(0);
    setUtilityReview(false);
    setWaterAmount(0);
    setViewAdders(0);
    setPvSystemAddOn(0);
  };

  const maxRebateOverDrive = () => {
    return (
      <div>
        {props.maximumOverDrive === 1 ? (
          +rebateOverride === 1 ? (
            <>
              <span>Rebate Override Amount:</span>
              <input
                className="form-control"
                placeholder="Rebate Override"
                name="rebateOverrideAmt"
                value={rebateOverrideAmt}
                onChange={(e) => setRebateOverrideAmt(+e.target.value)}
              ></input>
              <button
                type="button"
                className="btn btn-sm btn-outline-danger"
                onClick={() => setRebateOverride(0)}
              >
                Close
              </button>
            </>
          ) : (
            <>
              {/* {hybridRebate()} */}
              {utilityLocation === "Oregon" ? (
                <></>
              ) : (
                // <div style={{ display: 'flex', flexDirection: 'column' }} >
                //   {oregonRebate()}
                // </div>
                <>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => setRebateOverride(1)}
                  >
                    Rebate Override
                  </button>
                  {hybridRebate()}
                </>
              )}
            </>
          )
        ) : (
          <></>
        )}
      </div>
    );
  };

  const { projectID, edit, view } = props;

  const hybridRebate = () => {
    return (
      <>
        {+hasRebate > 0 ? (
          <>
            <form>
              <span>Full System Rebate? </span>
              <div>
                <span>Yes</span>
                <input
                  className="form-control"
                  type="radio"
                  name="partialRebate"
                  onChange={(e) => setPartialRebate(0)}
                  checked={partialRebate === 0 ? "checked" : ""}
                />
                <span>No</span>
                <input
                  className="form-control"
                  type="radio"
                  name="partialRebate"
                  onChange={(e) => setPartialRebate(1)}
                  checked={partialRebate === 1 ? "checked" : ""}
                />
              </div>
            </form>
            {partialRebate === 1 ? (
              <>
                <span>How many panels qualify for rebate?</span>
                <input
                  className="form-control"
                  type="number"
                  placeholder="# of panels"
                  max={panelAmount}
                  value={partialPanels}
                  onChange={(e) => setPartialPanels(+e.target.value)}
                ></input>
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </>
    );
  };

  const oregonRebate = () => {
    return (
      <>
        <button
          className={+hasRebate === 3 ? "buttonChecked" : "buttonUnchecked"}
          onClick={(e) => adderToggleOregon(hasRebate, setHasRebate, 3)}
        >
          {" "}
          ODOE $0.20
        </button>
        <button
          className={+hasRebate === 4 ? "buttonChecked" : "buttonUnchecked"}
          onClick={(e) => adderToggleOregon(hasRebate, setHasRebate, 4)}
        >
          {" "}
          ODOE $1.80
        </button>
      </>
    );
  };

  const multiAdderToggle = (item, op) => {
    return (
      <>
        {item === 1 || item === 2 ? (
          <>
            <form>
              <span>Who is receiving incentive: </span>
              <div>
                <span>Customer</span>
                <input
                  className="input"
                  type="radio"
                  name="ionRebate"
                  onChange={(e) => op(1)}
                  checked={item === 1 ? "checked" : ""}
                />
                <span>Rep</span>
                <input
                  className="input"
                  type="radio"
                  name="ionRebate"
                  onChange={(e) => op(2)}
                  checked={item === 2 ? "checked" : ""}
                />
              </div>
            </form>
          </>
        ) : (
          <></>
        )}
      </>
    );
  };

  const hybridBallast = () => {
    return (
      <>
        {ballast === 1 ? (
          <>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Switch
                    color="primary"
                    size="small"
                    checked={partialBallast === 0}
                    onChange={(e) =>
                      adderToggle(partialBallast, setPartialBallast)
                    }
                    name="partialBallast"
                  />
                }
                label="Full System"
                labelPlacement="start"
              />
            </FormGroup>
            {partialBallast === 1 ? (
              <>
                <span>How many panels are ballast?</span>
                <input
                  className="input"
                  placeholder="# of panels"
                  type="number"
                  max={panelAmount}
                  value={ballastPanels}
                  onChange={(e) => setBallastPanels(+e.target.value)}
                ></input>
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </>
    );
  };

  useEffect(() => {
    if (+waterSoftener > 0) {
      setWaterSoftenerAmount(4000 / +dealerFee);
    } else {
      setWaterSoftenerAmount(0);
    }
  }, [waterSoftener, dealerFee]);

  useEffect(() => {
    if (ballast === 1) {
      if (partialBallast === 1) {
        return setBallastTotal(+ballastPanels * +modSize * +ballastAmount);
      }
      setBallastTotal(+systemSize * +ballastAmount);
      setBallastPanels(+panelAmount);
    }
  }, [
    panelAmount,
    ballast,
    ballastPanels,
    partialBallast,
    ballastTotal,
    systemSize,
    systemCost,
    ballastAmount,
  ]);

  const hybridGroundMount = () => {
    return (
      <>
        {groundMount === 1 ? (
          <>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Switch
                    color="primary"
                    size="small"
                    checked={partialGroundMount === 0}
                    onChange={(e) =>
                      adderToggle(partialGroundMount, setPartialGroundMount)
                    }
                    name="partialGroundMount"
                  />
                }
                label="Full System"
                labelPlacement="start"
              />
            </FormGroup>
            {partialGroundMount === 1 ? (
              <>
                <span>How many ground mount panels?</span>
                <input
                  className="input"
                  placeholder="# of panels"
                  type="number"
                  max={panelAmount}
                  min="16"
                  value={groundMountPanels}
                  onChange={(e) => setGroundMountPanels(+e.target.value)}
                ></input>
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </>
    );
  };

  useEffect(() => {
    if (groundMount === 1) {
      if (partialGroundMount === 1) {
        return setGroundMountTotal(
          (+groundMountPanels * +modSize * +groundMountAmount) / +dealerFee,
        );
      }
      setGroundMountTotal((+systemSize * +groundMountAmount) / +dealerFee);
      setGroundMountPanels(+panelAmount);
    }
  }, [
    panelAmount,
    groundMount,
    groundMountPanels,
    partialGroundMount,
    groundMountTotal,
    systemSize,
    systemCost,
    groundMountAmount,
    dealerFee,
  ]);

  const adderButtons = () => {
    return (
      <>
        <div className="col-12">
          <p className="mb-0">
            <b>Maximum Adder Amount: </b>
            {adderMax.toLocaleString(undefined, {
              style: "currency",
              currency: "USD",
            })}
          </p>
          <p className="mb-0">
            <b>Remaining Adder Amount Before Dealer Fee: </b>
            {panelAmount > 0 ? (
              <span
                style={{
                  color:
                    +adderTotal - battery10Amount * battery10 > +adderMax
                      ? "rgba(232, 54, 54, 0.82)"
                      : "",
                }}
              >
                {" "}
                {((adderMax - adderTotal) * dealerFee).toLocaleString(
                  undefined,
                  {
                    style: "currency",
                    currency: "USD",
                  },
                )}
              </span>
            ) : (
              <span>N/A</span>
            )}
          </p>
        </div>
        <div className="col-12">
          <hr className="mt-2 mb-2"></hr>
        </div>

        {/* <div>Total Adders with Dealer Fees: ${adderTotal}</div> */}
        {props.maximumOverDrive && city === "Portland" ? (
          <div className="col-4 mt-2">
            <button
              type="button"
              className={
                !sustainable
                  ? "btn btn-outline-secondary w-100"
                  : "btn btn-primary w-100"
              }
              onClick={(e) => adderToggle(sustainable, setSustainable)}
            >
              Portland Adder
            </button>
          </div>
        ) : (
          ""
        )}

        {!["Virginia", "South Carolina"].includes(props.customer.state) && (
          <div className="col-4 mt-2">
            <button
              type="button"
              className={
                !ionRebate
                  ? "btn btn-outline-secondary w-100"
                  : "btn btn-primary w-100"
              }
              onClick={(e) => adderToggle2(ionRebate, setIonRebate)}
            >
              $500
            </button>
            {multiAdderToggle(ionRebate, setIonRebate)}
          </div>
        )}
        {salesTeam === "Development Sales Team" ||
        salesTeam === "OH BLK Sales Team" ||
        salesTeam === "HTX BLK Sales Team" ||
        salesTeam === "H-Town BLK Sales Team" ||
        salesTeam === "STX Sales Team" ||
        salesTeam === "NBTX Sales Team" ||
        salesTeam === "Tulsa Sales Team" ||
        blkAdder > 0 ? (
          <div className="col-4 mt-2">
            <button
              type="button"
              className={
                blkAdder
                  ? "btn btn-outline-secondary w-100"
                  : "btn btn-primary w-100"
              }
              onClick={(e) => adderToggle2(blkAdder, setBlkAdder)}
            >
              BLK $500
            </button>
            {multiAdderToggle(blkAdder, setBlkAdder)}
          </div>
        ) : null}
        {([
          "Development Sales Team",
          "Portland Sales Team",
          "Salem Sales Team",
          "Houston Sales Team",
          "Virginia Beach Sales Team",
          "Hampton Sales Team",
          "TX BLK Sales Team",
          "Austin Sales Team",
          "Richmond Sales Team",
          "STX Sales Team",
        ].includes(salesTeam) ||
          panelBonus > 0) &&
        +mod[0] === 19 ? (
          <div className="col-4 mt-2">
            <button
              type="button"
              className={
                panelBonus
                  ? "btn btn-outline-secondary w-100"
                  : "btn btn-primary w-100"
              }
              onClick={(e) => adderToggle2(panelBonus, setPanelBonus)}
            >
              Panel Bonus{" "}
            </button>
            {multiAdderToggle(panelBonus, setPanelBonus)}
          </div>
        ) : null}
        <div className="col-4 mt-2">
          <button
            type="button"
            className={
              !ballast
                ? "btn btn-outline-secondary w-100"
                : "btn btn-primary w-100"
            }
            onClick={(e) => adderToggle(ballast, setBallast)}
          >
            Ballast{" "}
          </button>

          {hybridBallast()}

          {props.maximumOverDrive ? (
            <input
              type="number"
              className="form-control"
              value={ballastAmount}
              onChange={(e) => setBallastAmount(e.target.value)}
              onBlur={() =>
                setBallastAmount(roundAndFormatNumber(ballastAmount, 4))
              }
            ></input>
          ) : (
            ""
          )}
        </div>
        {panelAmount >= 16 || props.maximumOverDrive ? (
          <div className="col-4 mt-2">
            <button
              type="button"
              className={
                !groundMount
                  ? "btn btn-outline-secondary w-100"
                  : "btn btn-primary w-100"
              }
              onClick={(e) => adderToggle(groundMount, setGroundMount)}
            >
              Ground Mount
            </button>
            {hybridGroundMount()}
            {props.maximumOverDrive ? (
              <input
                type="number"
                className="form-control"
                value={groundMountAmount}
                onChange={(e) => setGroundMountAmount(e.target.value)}
                onBlur={() =>
                  setGroundMountAmount(
                    roundAndFormatNumber(groundMountAmount, 4),
                  )
                }
              ></input>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div className="col-4 mt-2">
            <button
              type="button"
              className="btn btn-outline-secondary w-100 disabled"
            >
              Ground Mount
            </button>
          </div>
        )}
        <div className="col-4 mt-2">
          <button
            type="button"
            className={
              !pSolar
                ? "btn btn-outline-secondary w-100"
                : "btn btn-primary w-100"
            }
            onClick={(e) => adderToggle(pSolar, setPSolar)}
          >
            Pool Solar Removal
          </button>

          {props.maximumOverDrive ? (
            <input
              type="number"
              className="form-control"
              value={pSolarAmount}
              onChange={(e) => setPSolarAmount(e.target.value)}
              onBlur={() =>
                setPSolarAmount(roundAndFormatNumber(pSolarAmount, 4))
              }
            ></input>
          ) : (
            ""
          )}
        </div>
        <div className="col-4 mt-2">
          <button
            type="button"
            className={
              +msp === 2
                ? "btn btn-primary w-100"
                : "btn btn-outline-secondary w-100"
            }
            onClick={(e) => adderToggle2(msp, setMsp)}
          >
            MSP Upgrade
          </button>
          {props.maximumOverDrive ? (
            <input
              className="form-control"
              value={newMspAmount}
              onChange={(e) => setNewMspAmount(e.target.value)}
            ></input>
          ) : (
            ""
          )}
        </div>
        <div className="col-4 mt-2">
          <button
            type="button"
            disabled={+ballast === 1}
            className={
              !critterGuard
                ? "btn btn-outline-secondary w-100"
                : "btn btn-primary w-100"
            }
            onClick={(e) => adderToggle(critterGuard, setCritterGuard)}
          >
            Critter Guards
          </button>
          {/* {utilityLocation === 'Oregon' ? <button className={!sustainable ? ' buttonChecked buttonUnchecked' : 'buttonChecked'} onClick={e => adderToggle(sustainable, setSustainable)}>Sustainable Great</button> : ''} */}
          {props.maximumOverDrive ? (
            <input
              type="number"
              className="form-control"
              value={critterGuardAmount}
              onChange={(e) => setCritterGuardAmount(e.target.value)}
              onBlur={() =>
                setCritterGuardAmount(
                  roundAndFormatNumber(critterGuardAmount, 4),
                )
              }
            ></input>
          ) : (
            ""
          )}
        </div>
        {shouldRenderPowerWall(props.customer.territory) && (
          <div className="col-4 mt-2">
            <button
              className={
                battery10 >= 11 && battery10 < 20
                  ? "btn btn-primary w-100"
                  : "btn btn-outline-secondary w-100"
              }
              onClick={handlePowerWallClick}
            >
              Tesla PowerWall 3 Battery
            </button>
            {battery10 >= 11 && battery10 < 20 ? (
              <>
                <>
                  <div className="qualyText holders l">Amount</div>
                  <select
                    className="form-control"
                    onChange={handlePowerWallAmountChange}
                  >
                    <option
                      style={{
                        display: "none",
                        justifyContent: "space-between",
                      }}
                    >
                      {(battery10Amount * +dealerFee).toLocaleString(
                        undefined,
                        {
                          style: "currency",
                          currency: "USD",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        },
                      )}{" "}
                    </option>
                    {getPowerWallOptions(
                      props.customer.state,
                      loanA[1].includes("PPA") || loanA[1].includes("TPO"),
                    ).map((option) => (
                      <option
                        key={option.value}
                        value={option.value / +dealerFee}
                      >
                        {option.label}
                      </option>
                    ))}
                  </select>
                </>
                <>
                  <div className="qualyText holders l">Quantity</div>
                  <select
                    className="form-control"
                    value={battery10 - 10}
                    onChange={(e) => handlePowerWallQuantityChange(e)}
                  >
                    <option value="1" disabled={systemSizeAC >= 10}>
                      1
                    </option>
                    <option value="2">2</option>
                  </select>
                </>
                <>
                  <div className="qualyText holders l">Expansion Packs</div>
                  <select
                    className="form-control"
                    value={expansionPack}
                    onChange={(e) => {
                      setExpansionPack(+e.target.value);
                    }}
                  >
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4" disabled={battery10 < 12}>
                      4
                    </option>
                    <option value="5" disabled={battery10 < 12}>
                      5
                    </option>
                    <option value="6" disabled={battery10 < 12}>
                      6
                    </option>
                  </select>
                </>
              </>
            ) : (
              <></>
            )}

            {props.maximumOverDrive && (
              <input
                className="form-control"
                value={battery10Amount}
                onChange={(e) => setBattery10Amount(e.target.value)}
              />
            )}
          </div>
        )}

        <div className="col-4 mt-2">
          <button
            type="button"
            className={
              battery10 > 20
                ? "btn btn-primary w-100"
                : "btn btn-outline-secondary w-100"
            }
            onClick={handleBatteryClick}
          >
            Enphase 10c Battery
          </button>
          {battery10 > 20 && battery10 < 31 ? (
            <>
              <span># of batteries</span>
              <select
                className="form-control"
                value={battery10}
                onChange={(e) => {
                  const value = +e.target.value;
                  setBattery10(value);
                  setBattery10Amount(
                    // getEnphase10cAmount(value, props.customer.state) / +dealerFee
                    getEnphase10cFirstBatteryAmount(props.customer.state) /
                      +dealerFee,
                  ); // Adjust amount based on selection
                }}
              >
                {/* <option style={{ display: 'none' }}># of batteries</option> */}
                <option value="21">1</option>
                <option value="22">2</option>
                <option value="23">3</option>
                <option value="24">4</option>
                <option value="25">5</option>
                <option value="26">6</option>
                <option value="27">7</option>
                <option value="28">8</option>
                <option value="29">9</option>
                <option value="30">10</option>
              </select>
            </>
          ) : (
            <></>
          )}
          {props.maximumOverDrive ? (
            <input
              className="form-control"
              value={battery10Amount}
              onChange={(e) => setBattery10Amount(e.target.value)}
            ></input>
          ) : (
            ""
          )}
        </div>
        {salesTeam === "STX Sales Team" && (
          <div className="col-4 mt-2">
            <button
              type="button"
              className={
                !waterSoftener
                  ? "btn btn-outline-secondary w-100"
                  : "btn btn-primary w-100"
              }
              onClick={(e) => setWaterSoftener((prev) => (prev === 1 ? 0 : 1))}
            >
              Water Softener
            </button>
          </div>
        )}
        <div className="col-4 mt-2">
          <button
            type="button"
            className={
              !townhome
                ? "btn btn-outline-secondary w-100"
                : "btn btn-primary w-100"
            }
            onClick={(e) => {
              // Determine the new townhome value after toggle
              const newTownhomeValue = townhome === 1 || townhome === 2 ? 0 : 1;
              // Call adderToggle first
              adderToggle(townhome, setTownhome);
              // Then set sharedHome based on the new townhome value
              if (newTownhomeValue === 0) {
                setSharedHome(2);
              } else {
                setSharedHome(1);
              }
            }}
          >
            Townhome
          </button>
        </div>
        <div className="col-4 mt-2">
          <button
            type="button"
            className={
              !treeRemoval
                ? "btn btn-outline-secondary w-100"
                : "btn btn-primary w-100"
            }
            onClick={(e) => adderToggle(treeRemoval, setTreeRemoval)}
          >
            Tree Trimming
          </button>
          {treeRemoval ? (
            <input
              className="form-control"
              placeholder="Fixed Tree Removal Amount"
              onChange={(e) =>
                setTreeRemovalAmount((+e.target.value / dealerFee).toFixed(2))
              }
            ></input>
          ) : (
            <></>
          )}
        </div>
        <div className="col-4 mt-2">
          <button
            type="button"
            className={
              !pvSystemAddOn
                ? "btn btn-outline-secondary w-100"
                : "btn btn-primary w-100"
            }
            onClick={(e) => adderToggle(pvSystemAddOn, setPvSystemAddOn)}
          >
            PV System Add-On
          </button>
        </div>
        <div className="col-4 mt-2">
          <button
            type="button"
            className={
              reRoof
                ? "btn btn-primary w-100"
                : "btn btn-outline-secondary w-100"
            }
            onClick={() => setRoofingModalOpen(true)}
          >
            Add Re-Roof
          </button>
        </div>
        {"New Mexico" === props.customer.state && (
          <div className="col-4 mt-2">
            <button
              type="button"
              className={
                utilityReview
                  ? "btn btn-primary w-100"
                  : "btn btn-outline-secondary w-100"
              }
              onClick={(e) =>
                adderToggleBoolean(utilityReview, setUtilityReview)
              }
            >
              Utility Review
            </button>
          </div>
        )}
        <div className="col-4 mt-2">
          <button
            type="button"
            className={
              nest === 0
                ? "btn btn-outline-secondary w-100"
                : "btn btn-primary w-100"
            }
            onClick={() => adderToggleNest(nest, setNest)}
          >
            Nest
          </button>
          {nest > 0 ? (
            <>
              <span># of Smart Thermostats</span>
              <select
                className="form-control"
                value={nest}
                onChange={(e) => setNest(+e.target.value)}
              >
                {/* <option style={{ display: 'none' }}># of batteries</option> */}
                <option value="1">1</option>
                <option value="2">2</option>
              </select>
            </>
          ) : (
            <></>
          )}
        </div>

        {/* {+hasNest === 2 ? nestChanger() : ''} */}
        {utilityLocation === "Virginia" ? (
          nest > 0 ? (
            <div className="col-4 mt-2">
              <button
                className={
                  nestAdder === 0
                    ? "btn btn-outline-secondary w-100"
                    : "btn btn-primary w-100"
                }
                onClick={() => adderToggle(nestAdder, setNestAdder)}
              >
                VA Nest
              </button>
            </div>
          ) : (
            <div className="col-4 mt-2">
              <button className="btn btn-outline-secondary w-100">
                VA Nest
              </button>
            </div>
          )
        ) : (
          ""
        )}

        <ReRoofing
          loanProducts={loanProducts}
          loanA={loanA}
          utilityLocation={utilityLocation}
          roofAge={props.customer.roofAge}
          projectID={projectID}
          auroraDesignId={props.customer.auroraDesignId}
          roofQuote={roofQuote}
          setRoofQuote={setRoofQuote}
          reRoof={reRoof}
          setReRoof={setReRoof}
          setReRoofAmount={setReRoofAmount}
          reRoofAmount={reRoofAmount}
          adderToggle={adderToggle}
          dealerFee={dealerFee}
          roofSqFt={roofSqFt}
          setRoofSqFt={setRoofSqFt}
          roofType={roofType}
          setRoofType={setRoofType}
          sheathing={sheathing}
          setSheathing={setSheathing}
          roofImg={roofImg}
          setRoofImg={setRoofImg}
          isModalOpen={roofingModalOpen}
          setIsModalOpen={setRoofingModalOpen}
        />

        {/* <button className={!reRoof ? ' buttonChecked buttonUnchecked' : 'buttonChecked'} onClick={e => adderToggle(reRoof, setReRoof)}>Reroof</button>
      <input className='input' placeholder='Fixed amount' onChange={e => setReRoofAmount((+e.target.value / +dealerFee).toFixed(2))}></input> */}

        {+hasRebate === 1 ? (
          <></>
        ) : (
          <>
            <div className="col-12">
              <hr></hr>
              <b>Discounts:</b>
            </div>
            {+hasRebate === 1 ? (
              <></>
            ) : (
              <>
                {sameDay === 1 || referral === 1 ? (
                  <div className="col-4 mt-2">
                    <button
                      type="button"
                      className="btn btn-outline-secondary w-100"
                      style={{ color: "rgb(150, 150, 150, .1)" }}
                    >
                      Preferred Utility Discount
                    </button>
                  </div>
                ) : (
                  <div className="col-4 mt-2">
                    <button
                      className={
                        !preferredUtility
                          ? "btn btn-outline-secondary w-100"
                          : "btn btn-primary w-100"
                      }
                      onClick={(e) =>
                        adderToggle(preferredUtility, setPreferredUtility)
                      }
                    >
                      Preferred Utility Discount
                    </button>
                  </div>
                )}
              </>
            )}
          </>
        )}
      </>
    );
  };

  const nestChanger = () => {
    return (
      <form>
        <div>
          <span>10%</span>
          <input
            className="input"
            type="radio"
            name="nest"
            onChange={(e) => setNest(1)}
            checked={nest === 1 ? "checked" : ""}
          />
          <span>5%</span>
          <input
            className="input"
            type="radio"
            name="nest"
            onChange={(e) => setNest(2)}
            checked={nest === 2 ? "checked" : ""}
          />
        </div>
      </form>
    );
  };

  let designTypes = [];

  if (designType) {
    designTypes = designType.split(";");
    // console.log(designTypes)
  }
  // console.log(customer)
  useEffect(() => {
    setStoryAmount(stories);
    if (props.currentProp.financingAmount > 0) {
      setImagery(1);
      setMeterAgg(2);
      setSharedHome(2);
      setTrenching(2);
      setAddon(2);
      setDesignLimited(limitedSpace);
    }
    if (surveyType) {
      for (let i = 0; i <= surveyTypes.length; i++) {
        if (surveyTypes[i] === "Traditional") {
          setImagery(2);
        }
        if (surveyTypes[i] === "GoPro") {
          setImagery(1);
        }
      }
    }
    if (designType) {
      for (let i = 0; i <= designTypes.length; i++) {
        if (designTypes[i] === "Roof Measurements") {
          setImagery(2);
        }
        if (designTypes[i] === "Digital Meter Aggregation") {
          setMeterAgg(1);
        }
        if (designTypes[i] === "Electrical Trenching") {
          setTrenching(1);
        }
        if (designTypes[i] === "MultiFamily/Shared Roofs") {
          setSharedHome(1);
        }
        if (designTypes[i] === "Add-on") {
          setAddon(1);
          setPvSystemAddOn(1);
        }
      }
    }
  }, [surveyType, designType, edit]);

  useEffect(() => {
    if (+sharedHome === 1) {
      setTownhomeAmount(400 / +dealerFee);
      return setTownhome(1);
    } else {
      setTownhome(0);
    }
  }, [sharedHome, dealerFee]);

  let surveyString = "Traditional";
  if (imagery === 1) {
    surveyString = "GoPro";
  }

  let surveys = [surveyString];

  const questionnaire = () => {
    return (
      <>
        <div className="col-9">
          Did Aurora have sufficient satellite imagery to model accurately?
        </div>
        <div className="col-3">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="imagery"
              id="imagery1"
              onChange={(e) => setImagery(1)}
              checked={imagery === 1 ? "checked" : ""}
            />
            <label className="form-check-label" for="imagery1">
              Yes
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="imagery"
              id="imagery2"
              onChange={(e) => setImagery(2)}
              checked={imagery === 2 ? "checked" : ""}
            />
            <label className="form-check-label" for="imagery2">
              No
            </label>
          </div>
        </div>
        <div className="col-12">
          <hr className="mt-2 mb-2"></hr>
        </div>

        <div className="col-9">Are we aggregating meters?</div>
        <div className="col-3">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="meterAgg"
              id="meterAgg1"
              onChange={(e) => setMeterAgg(1)}
              checked={meterAgg === 1 ? "checked" : ""}
            />
            <label className="form-check-label" for="meterAgg1">
              Yes
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="meterAgg"
              id="meterAgg2"
              onChange={(e) => setMeterAgg(2)}
              checked={meterAgg === 2 ? "checked" : ""}
            />
            <label className="form-check-label" for="meterAgg2">
              No
            </label>
          </div>
        </div>
        <div className="col-12">
          <hr className="mt-2 mb-2"></hr>
        </div>

        <div className="col-9">
          Is the home a shared roof/multifamily/townhome?
        </div>
        <div className="col-3">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="sharedHome"
              id="sharedHome1"
              onChange={(e) => setSharedHome(1)}
              checked={sharedHome === 1 ? "checked" : ""}
            />
            <label className="form-check-label" for="sharedHome1">
              Yes
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="sharedHome"
              id="sharedHome2"
              onChange={(e) => setSharedHome(2)}
              checked={sharedHome === 2 ? "checked" : ""}
            />
            <label className="form-check-label" for="sharedHome2">
              No
            </label>
          </div>
        </div>
        <div className="col-12">
          <hr className="mt-2 mb-2"></hr>
        </div>

        <div className="col-9">
          Was any part of the system designed on a detached structure?
        </div>
        <div className="col-3">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="trenching"
              id="trenching1"
              onChange={(e) => setTrenching(1)}
              checked={trenching === 1 ? "checked" : ""}
            />
            <label className="form-check-label" for="trenching1">
              Yes
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="trenching"
              id="trenching2"
              onChange={(e) => setTrenching(2)}
              checked={trenching === 2 ? "checked" : ""}
            />
            <label className="form-check-label" for="trenching2">
              No
            </label>
          </div>
        </div>
        <div className="col-12">
          <hr className="mt-2 mb-2"></hr>
        </div>

        <div className="col-9">Is this an add-on system?</div>
        <div className="col-3">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="addon"
              id="addon1"
              onChange={(e) => {
                setAddon(1);
                setPvSystemAddOn(1);
              }}
              checked={addon === 1 ? "checked" : ""}
            />
            <label className="form-check-label" for="addon1">
              Yes
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="addon"
              id="addon2"
              onChange={(e) => {
                setAddon(2);
                setPvSystemAddOn(0);
              }}
              checked={addon === 2 ? "checked" : ""}
            />
            <label className="form-check-label" for="addon2">
              No
            </label>
          </div>
        </div>
        <div className="col-12">
          <hr className="mt-2 mb-2"></hr>
        </div>

        <div className="col-9">Was the system size limited by roof space?</div>
        <div className="col-3">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="designLimited"
              id="designLimited1"
              onChange={(e) => setDesignLimited("Yes")}
              checked={designLimited === "Yes" ? "checked" : ""}
            />
            <label className="form-check-label" for="designLimited1">
              Yes
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="designLimited"
              id="designLimited2"
              onChange={(e) => setDesignLimited("No")}
              checked={designLimited === "No" ? "checked" : ""}
            />
            <label className="form-check-label" for="designLimited2">
              No
            </label>
          </div>
        </div>
        <div className="col-12">
          <hr className="mt-2 mb-2"></hr>
        </div>

        <div className="col-9">Shade Disclosure?</div>
        <div className="col-3">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="addShadeWaiver"
              id="addShadeWaiver1"
              onChange={(e) => setAddShadeWaiver(1)}
              checked={addShadeWaiver ? "checked" : ""}
            />
            <label className="form-check-label" for="addShadeWaiver1">
              Yes
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="addShadeWaiver"
              id="addShadeWaiver2"
              onChange={(e) => setAddShadeWaiver(0)}
              checked={addShadeWaiver === 0 ? "checked" : ""}
            />
            <label className="form-check-label" for="addShadeWaiver2">
              No
            </label>
          </div>
        </div>
        <div className="col-12">
          <hr className="mt-2 mb-2"></hr>
        </div>

        <div className="col-9">How many stories is the home?</div>
        <div className="col-3">
          <select
            className="form-control"
            onChange={(e) => setStoryAmount(e.target.value)}
          >
            <option style={{ display: storyAmount ? "none" : "" }}># of Stories</option>
            <option value="1 Story">1 Story</option>
            <option value="2 Story">2 Story</option>
            <option value="3 + Story">3 + Story</option>
          </select>
        </div>
      </>
    );
  };

  let uType = usageType;

  const getRoofQuote = () => {
    axios
      .post(apiUrl, { method: "get_roof_quote", project_id: projectID })
      .then((res) => {
        // console.log(res.data)
        return [setRoofQuote(res.data.roofQuote)];
      });
  };

  const getRoofQuotesPerProject = () => {
    axios
      .post(apiUrl, {
        method: "get_roof_quotes_per_project",
        project_id: projectID,
      })
      .then((res) => {
        // console.log(res.data)
        return [setRoofQuotes(res.data.data)];
      });
  };

  useEffect(() => {
    if (projectID) {
      getRoofQuote();
      getRoofQuotesPerProject();
    }
  }, [projectID]);

  const mappedRoofQuotes = roofQuotes.map((roofQuote, i) => (
    <div className="propButton" key={i}>
      <Link target="_blank" to={`/roofProp/${roofQuote.tempId}`}>
        <button>
          {+roofQuote.loanId === 0
            ? `${(+roofQuote.roofQuoteAmount).toLocaleString(undefined, {
                style: "currency",
                currency: "USD",
              })} Cash`
            : `${(+roofQuote.roofQuoteAmount).toLocaleString(undefined, {
                style: "currency",
                currency: "USD",
              })} ${roofQuote.loanName} ${roofQuote.loanTerm} ${
                roofQuote.loanInterest
              }%`}
        </button>
      </Link>
    </div>
  ));

  const additionalBatteryAmount2 =
    (props.customer.state === "Illinois" ? 10000 : 13000) / +dealerFee;
  const additionalBatteryAmount =
    (props.customer.state === "Illinois" || props.customer.state === "Texas"
      ? battery10Amount
      : 12500) / +dealerFee;
  /**
   * This is a list of adders that are rendered shwoing the amount with and without the dealer fee if it is selected.
   */
  const adders = [
    {
      name: "Travel Adder",
      amount: travelAdderAmount,
      amountNoDealerFee: travelAdderAmount * dealerFee,
      condition: !!travelAdder,
    },
    {
      name: "Small System Adder",
      amount: smallSystemAdderAmount,
      amountNoDealerFee: smallSystemAdderAmount * +dealerFee,
      condition: !!smallSystemAdder,
    },
    {
      name: "Rep/Customer Rebate",
      amount: adderAmount,
      amountNoDealerFee: 500,
      condition: !!ionRebate,
    },
    {
      name: "Panel Bonus",
      amount: panelBonusAmount,
      amountNoDealerFee: panelBonusAmount * dealerFee,
      condition: !!panelBonus,
    },
    {
      name: "BLK Adder",
      amount: blkAdderAmount,
      amountNoDealerFee: 500,
      condition: !!blkAdder,
    },
    {
      name: "Townhome Adder",
      amount: townhomeAmount,
      amountNoDealerFee: townhomeAmount * dealerFee,
      condition: !!townhome,
    },
    {
      name: "Nest Adder",
      amount: nestCost,
      amountNoDealerFee: nestCost * dealerFee,
      condition: !!nest,
    },
    {
      name: "Ballast Adder",
      amount: ballastTotal,
      amountNoDealerFee: ballastTotal * dealerFee,
      condition: !!ballast,
    },
    {
      name: "Ground Mount Adder",
      amount: groundMountTotal,
      amountNoDealerFee: groundMountTotal * dealerFee,
      condition: !!groundMount,
    },
    {
      name: "Pool Solar",
      amount: pSolarAmount * systemSize,
      amountNoDealerFee: pSolarAmount * systemSize * dealerFee,
      condition: !!pSolar,
    },
    {
      name: "MSP",
      amount: msp === 1 ? mspAmount : newMspAmount,
      amountNoDealerFee: (msp === 1 ? mspAmount : newMspAmount) * dealerFee,
      condition: !!msp,
    },
    {
      name: "Critter Guard",
      amount: critterGuardAmount * systemSize,
      amountNoDealerFee: critterGuardAmount * systemSize * dealerFee,
      condition: !!critterGuard,
    },
    {
      name: "Battery 3",
      amount: battery3Amount * dealerFee,
      amountNoDealerFee: battery3Amount * dealerFee,
      condition: !!battery3,
    },
    {
      name: `Enphase 10c Battery x${battery10 - 20}`,
      amount: +battery10Amount + additionalBatteryAmount2 * (battery10 - 21),
      amountNoDealerFee:
        (+battery10Amount + additionalBatteryAmount2 * (battery10 - 21)) *
        +dealerFee,
      condition: battery10 > 20 && battery10 < 31,
    },
    {
      name: `Tesla PowerWall x${battery10 - 10}`,
      amount: +battery10Amount + additionalBatteryAmount * (battery10 - 11),
      amountNoDealerFee:
        (+battery10Amount + additionalBatteryAmount * (battery10 - 11)) *
        +dealerFee,
      condition: battery10 >= 11 && battery10 < 20,
    },
    {
      name: `Expansion Pack x${expansionPack}`,
      amount: expansionPackAmount * expansionPack,
      amountNoDealerFee: expansionPackAmount * expansionPack * dealerFee,
      condition: !!expansionPack && battery10 >= 11 && battery10 < 20,
    },
    {
      name: "AC Coupled",
      amount: 1500 / +dealerFee,
      amountNoDealerFee: 1500,
      condition:
        (loanA?.[1]?.includes("PPA") || loanA?.[1]?.includes("TPO")) &&
        battery10 >= 11 &&
        battery10 < 20,
    },
    {
      name: "Permitting Adder",
      amount: permittingAdderAmount * systemSize,
      amountNoDealerFee: permittingAdderAmount * systemSize * dealerFee,
      condition: !!permittingAdder,
    },
    {
      name: "Tree Removal",
      amount: treeRemovalAmount,
      amountNoDealerFee: treeRemovalAmount * dealerFee,
      condition: !!treeRemoval,
    },
    {
      name: "Utility Review",
      amount: utilityReviewAmount,
      amountNoDealerFee: utilityReviewAmount * dealerFee,
      condition: !!utilityReview,
    },
    {
      name: "Re-roof",
      amount: reRoofAmount,
      amountNoDealerFee: reRoofAmount * dealerFee,
      condition: !!reRoof,
    },
    {
      name: "Sustainable",
      amount: sustainableAmount,
      amountNoDealerFee: sustainableAmount * dealerFee,
      condition: !!sustainable,
    },
    {
      name: "PV System Add-On",
      amount: pvSystemAddOnAmount,
      amountNoDealerFee: pvSystemAddOnAmount * dealerFee,
      condition: !!pvSystemAddOn,
    },
    {
      name: "AC Couple",
      amount: +acCoupledAmount,
      amountNoDealerFee: +acCoupledAmount * dealerFee,
      condition: !!acCoupled,
    },
    {
      name: "Water Softener",
      amount: +waterSoftenerAmount,
      amountNoDealerFee: +waterSoftenerAmount * dealerFee,
      condition: !!waterSoftener,
    },
    {
      name: "Total",
      amount: adderTotal,
      amountNoDealerFee: adderTotal * dealerFee,
      condition: true,
    },
  ];

  return (
    <>
      {}
      <>
        {roofQuotes.length > 0 ? (
          <section name="roofQuotesButton">
            {viewRoofQuotes ? (
              <>
                <Modal
                  isOpen={viewRoofQuotes}
                  onClose={() => setViewRoofQuotes(!viewRoofQuotes)}
                  title="Roof Quotes"
                  showCloseButton={true}
                  closeOnOverlayClick={true}
                  className=""
                >
                  <div className="roof-quotes-modal">{mappedRoofQuotes}</div>
                </Modal>
              </>
            ) : (
              <button onClick={() => setViewRoofQuotes(!viewRoofQuotes)}>
                Roof Quotes
              </button>
            )}
          </section>
        ) : (
          <></>
        )}

        {edit || proposals < 0 ? (
          <></>
        ) : (
          <section name="reRoofing">
            <div className="container bg-dark text-white text-end">
            <ReRoofing
              utilityLocation={utilityLocation}
              getRoofQuotesPerProject={getRoofQuotesPerProject}
              loanProducts={loanProducts}
              loanA={loanA}
              adders={props.adders}
              services={props.services}
              financeId={props.customer.financeId}
              designId={props.customer.designId}
              getRoofQuote={getRoofQuote}
              edit={props.edit}
              projectID={projectID}
              auroraDesignId={props.customer.auroraDesignId}
              roofQuote={roofQuote}
              setRoofQuote={setRoofQuote}
              reRoof={reRoof}
              setReRoof={setReRoof}
              setReRoofAmount={setReRoofAmount}
              reRoofAmount={reRoofAmount}
              adderToggle={adderToggle}
              dealerFee={dealerFee}
              roofSqFt={roofSqFt}
              setRoofSqFt={setRoofSqFt}
              roofType={roofType}
              setRoofType={setRoofType}
              sheathing={sheathing}
              setSheathing={setSheathing}
              roofImg={roofImg}
              setRoofImg={setRoofImg}
              isModalOpen={roofingModalOpen}
              setIsModalOpen={setRoofingModalOpen}
            />
            </div>
          </section>
        )}

        {props.utility ? (
          <section
            name="utilityInformation"
            style={{ backgroundColor: "#ededed", paddingBottom: "50px" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-md-8 pe-0">
                  <div
                    className="h-100 p-5 text-white text-start"
                    style={{ backgroundColor: "#004a70" }}
                  >
                    {totalUsage ? (
                      <>
                        <div>
                          <div className="row text-center">
                            <div className="col-sm-2 usage-grid">
                              Jan: {usage[0]}{" "}
                            </div>
                            <div className="col-sm-2 usage-grid">
                              Feb: {usage[1]}{" "}
                            </div>
                            <div className="col-sm-2 usage-grid">
                              Mar: {usage[2]}{" "}
                            </div>
                            <div className="col-sm-2 usage-grid">
                              Apr: {usage[3]}{" "}
                            </div>
                            <div className="col-sm-2 usage-grid">
                              May: {usage[4]}{" "}
                            </div>
                            <div className="col-sm-2 usage-grid">
                              Jun: {usage[5]}{" "}
                            </div>
                          </div>
                          <div className="row text-center">
                            <div className="col-sm-2 usage-grid">
                              Jul: {usage[6]}{" "}
                            </div>
                            <div className="col-sm-2 usage-grid">
                              Aug: {usage[7]}{" "}
                            </div>
                            <div className="col-sm-2 usage-grid">
                              Sep: {usage[8]}{" "}
                            </div>
                            <div className="col-sm-2 usage-grid">
                              Oct: {usage[9]}{" "}
                            </div>
                            <div className="col-sm-2 usage-grid">
                              Nov: {usage[10]}{" "}
                            </div>
                            <div className="col-sm-2 usage-grid">
                              Dec: {usage[11]}{" "}
                            </div>
                          </div>

                          {uType === "Square Footage" ? (
                            <></>
                          ) : (
                            <>
                              <OffsetChart
                                uType={uType}
                                usage={usage}
                                production={production}
                                systemSize={systemSize}
                                totalProduction={totalProduction}
                                nestAmount={nestAmount}
                                currentUsage={currentUsage}
                              />
                            </>
                          )}
                        </div>

                        <div className="row mt-3">
                          <div className="col-md-3 mb-4">
                            <div className="card bg-light bg-gradient">
                              <div className="card-body p-2 text-center">
                                <div className="text-success text-uppercase pb-2 mb-2">
                                  100% Offset
                                </div>
                                <div className="h5 mb-0 font-weight-bold text-dark">
                                  {" "}
                                  {Math.floor(
                                    (totalUsage * 1.1) /
                                      ((1700 / 1000) * mod[3]),
                                  )}
                                  -
                                  {Math.floor(
                                    (totalUsage * 1.1) /
                                      ((1400 / 1000) * mod[3]),
                                  )}{" "}
                                  panels
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3 mb-4">
                            <div className="card bg-light bg-gradient">
                              <div className="card-body p-2 text-center">
                                <div className="text-success text-uppercase pb-2 mb-2">
                                  Annual Usage
                                </div>
                                <div className="h5 mb-0 font-weight-bold text-dark">
                                  {" "}
                                  {billCalc[2].toLocaleString(undefined)} kWh
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3 mb-4">
                            <div className="card bg-light bg-gradient">
                              <div className="card-body p-2 text-center">
                                <div className="text-success text-uppercase pb-2 mb-2">
                                  Average Usage
                                </div>
                                <div className="h5 mb-0 font-weight-bold text-dark">
                                  {billCalc[4]} kWh
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3 mb-4">
                            <div className="card bg-light bg-gradient">
                              <div className="card-body p-2 text-center">
                                <div className="text-success text-uppercase pb-2 mb-2">
                                  Usage Type
                                </div>
                                <div className="h5 mb-0 font-weight-bold text-dark">
                                  {props.usageType}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3 mb-4">
                            <div className="card bg-light bg-gradient">
                              <div className="card-body p-2 text-center">
                                <div className="text-success text-uppercase pb-2 mb-2">
                                  Annual Bill
                                </div>
                                <div className="h5 mb-0 font-weight-bold text-dark">
                                  {" "}
                                  {billCalc[3].toLocaleString(undefined, {
                                    style: "currency",
                                    currency: "USD",
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3 mb-4">
                            <div className="card bg-light bg-gradient">
                              <div className="card-body p-2 text-center">
                                <div className="text-success text-uppercase pb-2 mb-2">
                                  Average Bill
                                </div>
                                <div className="h5 mb-0 font-weight-bold text-dark">
                                  ${billCalc[1]}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3 mb-4">
                            <div className="card bg-light bg-gradient">
                              <div className="card-body p-2 text-center">
                                <div className="text-success text-uppercase pb-2 mb-2">
                                  Doing Nothing
                                </div>
                                <div className="h5 mb-0 font-weight-bold text-dark">
                                  {Math.round(total(years) * 12).toLocaleString(
                                    undefined,
                                    {
                                      style: "currency",
                                      currency: "USD",
                                    },
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3 mb-4">
                            <div className="card bg-light bg-gradient">
                              <div className="card-body p-2 text-center">
                                <div className="text-success text-uppercase pb-2 mb-2">
                                  Price Per kWh
                                </div>
                                <div className="h5 mb-0 font-weight-bold text-dark">
                                  ${(billCalc[1] / billCalc[4]).toFixed(3)}
                                  /kWh
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {props.usageType === "Square Footage" &&
                        custUtility === "NV Energy" ? (
                          <span style={{ color: "rgba(232, 54, 54, 0.82)" }}>
                            NV Energy Max Panels for Sq Footage:{" "}
                            {props.nvSqFoot}
                          </span>
                        ) : (
                          ""
                        )}

                        {rateOverRide ? (
                          <div className="row">
                            <div className="col-3">
                              <button
                                type="button"
                                className={"btn btn-info w-100 text-white"}
                                onClick={() => {
                                  adderToggle(rateOverRide, setRateOverRide);
                                  setCustomRate(!customRate);
                                }}
                              >
                                Current kWh Override
                              </button>
                            </div>
                            <div className="col-6">
                              <input
                                className="form-control"
                                placeholder="kWh rate override"
                                onChange={(e) =>
                                  setRateOverRideAmount(+e.target.value)
                                }
                              ></input>
                            </div>
                          </div>
                        ) : (
                          <div className="row">
                            <div className="col-3">
                              <button
                                type="button"
                                className={"btn btn-outline-info text-white"}
                                onClick={() => {
                                  adderToggle(rateOverRide, setRateOverRide);
                                  setCustomRate(!customRate);
                                }}
                              >
                                Current kWh Override
                              </button>
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <h2>Please Add Usage</h2>
                      </>
                    )}
                  </div>
                </div>
                <div className="col-md-4 ps-0">
                  <div className="h-100 ps-5 pe-5 pt-5 text-white bg-secondary text-start">
                    <h3>Current Prop Info in SF</h3>
                    <div className="row">
                      <div className="col-12">
                        <b>Loan Amount: </b>{" "}
                        {(+props.currentProp.financingAmount).toLocaleString(
                          undefined,
                          {
                            style: "currency",
                            currency: "USD",
                          },
                        )}
                      </div>
                      <div className="col-12">
                        <b>Rebate: </b>{" "}
                        {(+props.currentProp.rebate).toLocaleString(undefined, {
                          style: "currency",
                          currency: "USD",
                        })}
                      </div>
                      <div className="col-12">
                        <b>Panel Amount: </b>{" "}
                        {Math.round(props.currentProp.panelAmount)}{" "}
                        {props.currentProp.panel}
                      </div>
                      <div className="col-12">
                        <b>System Size: </b>{" "}
                        {props.currentProp.systemSize / 1000}kW
                      </div>
                      <div className="col-12">
                        <b>Design Type: </b> {designType}
                      </div>

                      <div className="col-12">
                        <hr></hr>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <b>Adders: </b>
                        {mappedAdders}
                      </div>
                      <div className="col-12">
                        <hr></hr>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        {["Virginia", "Ohio", "Illinois"].includes(
                          props.customer.state
                        ) && !isSelectedFinancePpa ? (
                          <>
                            <button
                              type="button"
                              className="btn btn-info w-100 text-white"
                              onClick={() =>
                                createRecAcct(
                                  props.customer,
                                  mod,
                                  inverter[1],
                                  inverter[2],
                                  props.currentProp.systemSize,
                                  systemSizeAC,
                                  displayProd,
                                  props.rebate.csUtilityId,
                                  setShowError,
                                  setErrorMessage,
                                )
                              }
                            >
                              Create and send SREC Docs
                            </button>
                            {showError ? (
                              <>
                                <div className="row justify-content-center">
                                  <div className="col" align="center">
                                    <div className="errorMessage">
                                      {errorMessage}
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <>
            <div className="filler"></div>
            <div className="filler"></div>
            <div className="loading-box2">
              <CircularProgress size={60} color="inherit" />
            </div>
            <div className="filler"></div>
            <div className="filler"></div>
          </>
        )}

        {/* {console.log(1, basePpw, ppw, team)} */}
        <Proposals
          recProduct={props.customer.srecProduct}
          utilityLseId={utilityLseId}
          utilityPpa={utilityPpa}
          maxOverDrive={props.maximumOverDrive}
          townhome={townhome}
          imagery={imagery}
          meterAgg={meterAgg}
          setProposals={setProposals}
          roofQuote={roofQuote}
          setRoofQuote={setRoofQuote}
          city={city}
          state={props.customer.state}
          designLimited={designLimited}
          usageType={usageType}
          projectID={projectID}
          getCustomer={props.getCustomer}
          team={team}
          surveys={surveys}
          storyAmount={storyAmount}
          sharedHome={sharedHome}
          trenching={trenching}
          addon={addon}
          totalUsage={totalUsage}
          adders={props.adders}
          basePpw={props.ppw}
          step={step}
          nestAmount={nestAmount}
          utilityLocation={utilityLocation}
          billCalc={billCalc[2]}
          edit={edit}
          view={view}
          propCloning={propCloning}
          setBasePpw={setBasePpw}
          setPropRebate={setRebate}
          syncPropId={currentProp.syncPropId}
          contractSigned={currentProp.contractSigned}
          designType={designType}
          lightReachAccountId={props.customer.lightReachAccountId}
        />

        <section name="buildSystemButtons" className="pt-5 bg-dark">
          <div className="container">
            <div className="row">

            {!props.edit ? (

              <div className="col-12 text-center">
         
                  <button
                    type="button"
                    className="btn btn-outline-info text-white"
                    style={{ width: "300px" }}
                    onClick={() => {
                      props.setEdit(true);
                      props.provideSalesTeam();
                    }}
                  >
                    Build System
                  </button>
                
              </div>
              ) : (
                <div className="col-12">
                  <button
                    type="button"
                    className="btn btn-outline-danger float-end ms-3"
                    style={{ width: "100px" }}
                    onClick={() => {
                      props.setEdit(false);
                      cancel();
                    }}
                  >
                    Cancel
                  </button>
                
                  {props.maximumOverDrive ? (
                    <>
                      <div>
                        <button
                          type="button"
                          className="btn btn-danger float-end"
                          style={{ width: "300px" }}
                          onClick={() => props.setMaximumOverDrive(0)}
                        >
                          {" "}
                          Maximum OverDrive: Restrictions Off
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <button
                          type="button"
                          className="btn btn-outline-warning float-end"
                          style={{ width: "300px" }}
                          onClick={() => props.maxOverDrive()}
                        >
                          {" "}
                          Maximum OverDrive: Restrictions On
                        </button>
                      </div>
                    </>
                  )}
                  {props.repInfo()}
                
              </div>
              )}
              
            </div>
          </div>
        </section>

        <section name="buildSystem" className="pt-4 pb-5 bg-dark text-white">
          <div className="container">
            {props.edit ? (
              <>
                <div className="row mb-4">
                  <div className="col-12" style={{ minHeight: "50px" }}>
                    <div className="statuses">
                      <div className="status">
                        <img
                          src={!img ? StatusIncompleteDark : StatusCompleteDark}
                        ></img>
                        <div className="statusName">
                          <span>Design</span>
                        </div>
                      </div>
                      <div className="status">
                        <img
                          src={
                            panelAmount >= 6 &&
                            maxModCount > 0 &&
                            arrayCount > 0
                              ? StatusCompleteDark
                              : StatusIncompleteDark
                          }
                        ></img>
                        <div className="statusName">
                          <span>Modules</span>
                        </div>
                      </div>
                      <div className="status">
                        <img
                          src={
                            decProduction
                              ? StatusCompleteDark
                              : StatusIncompleteDark
                          }
                        ></img>
                        <div className="statusName">
                          <span>Production</span>
                        </div>
                      </div>
                      <div className="status">
                        <img
                          src={
                            !totalUsage
                              ? StatusIncompleteDark
                              : StatusCompleteDark
                          }
                        ></img>
                        <div className="statusName">
                          <span>Usage</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row my-3 px-2">
                  <div className="col-12 p-2 rounded-3 bg-secondary bg-gradient text-white">
                    <p className="mb-0">
                      <b>Notes:</b> {props.chat}
                    </p>
                  </div>
                </div>

                <div className="row text-dark">
                  <div className="col-3">
                    <div className="card h-100">
                      <div className="card-header">
                        <h5 className="text-center mb-0">
                          {custUtility} Building Stipulations
                        </h5>
                      </div>

                      <div className="card-body">
                        <p className="mb-0">
                          <b>Max Offset:</b>{" "}
                          {maxOffset ? maxOffset + "%" : "N/A"}{" "}
                        </p>

                        <p className="mb-0">
                          <b>Max System Size:</b>{" "}
                          {maxSystemSize ? maxSystemSize / 1000 + " kW" : "N/A"}
                        </p>

                        {utilityLocation === "Oregon" && hasRebate > 0 ? (
                          <>
                            <p className="mb-0">
                              <b>Minimum TSRF:</b> 80%{" "}
                            </p>
                            <p className="mb-0">
                              <b>Minimum Irradiance:</b> {irradiance}{" "}
                            </p>
                          </>
                        ) : (
                          <>
                            <p className="mb-0">
                              <b>Minimum Irradiance:</b> {irradiance}{" "}
                            </p>
                          </>
                        )}
                        {custUtility === "Colorado Springs Utilities" ? (
                          <p className="mb-0">
                            <b>Azimuth Restrictions:</b> 90&#176;-270&#176;{" "}
                          </p>
                        ) : (
                          ""
                        )}
                        {custUtility &&
                        props.usageType === "Square Footage" &&
                        custUtility === "NV Energy" ? (
                          <p className="mb-0">
                            <b>NV Energy Max Panels for Sq Footage:</b>{" "}
                            {props.nvSqFoot}{" "}
                          </p>
                        ) : (
                          ""
                        )}
                        {custUtility &&
                        props.usageType === "Square Footage" &&
                        utilityLocation === "Colorado" ? (
                          <p className="mb-0">
                            <b>Colorado Max Production for Sq Footage:</b>{" "}
                            {props.xcelSqFoot}{" "}
                          </p>
                        ) : (
                          ""
                        )}
                        {utilityLocation === "Nevada" ? (
                          <p className="mb-0">
                            <b>
                              Total System Cannot Exceed $250,000 in Nevada
                            </b>{" "}
                          </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="card h-100">
                      <div className="card-header">
                        <h5 className="text-center mb-0">Option 1</h5>
                      </div>

                      <div className="card-body">
                        <p
                          className="mb-1 text-center"
                          style={{ fontSize: "18px" }}
                        >
                          <b>
                            {loanA[1]} {loanA[2]} year {loanA[3]}%
                          </b>
                        </p>

                        <p className="mb-0">
                          <b>ITC Applied:</b> $
                          {panelAmount
                            ? Math.round(loanA[4] * loanAmount)
                            : "0"}
                        </p>
                        {stateTaxPayment()}
                        <p className="mb-0">
                          <b>ITC not Applied:</b> $
                          {panelAmount
                            ? Math.round(loanA[5] * loanAmount)
                            : "0"}
                        </p>

                        <p className="mb-0">
                          <b>Interest Only: </b>
                          {loanA[6] > 0
                            ? Math.round(loanA[6] * loanAmount)
                            : "N/A"}
                        </p>

                        <p className="mb-0">
                          <b>30 Year Savings:</b>{" "}
                          {panelAmount
                            ? loan1Savings.toLocaleString(undefined, {
                                style: "currency",
                                currency: "USD",
                              })
                            : "$0"}
                        </p>

                        <hr></hr>
                        <select
                          className="form-select"
                          onChange={(e) => setLoanA(e.target.value.split(","))}
                        >
                          <option>Change Option 1</option>
                          {mappedLoans}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="card h-100">
                      <div className="card-header">
                        <h5 className="text-center mb-0">Option 2</h5>
                      </div>

                      <div className="card-body">
                        <p
                          className="mb-1 text-center"
                          style={{ fontSize: "18px" }}
                        >
                          <b>
                            {loanB[1]} {loanB[2]} year {loanB[3]}%
                          </b>
                        </p>

                        <p className="mb-0">
                          <b>ITC Applied:</b> $
                          {panelAmount
                            ? Math.round(loanB[4] * loanAmount)
                            : "0"}
                        </p>

                        <p className="mb-0">
                          <b>ITC not Applied:</b> $
                          {panelAmount
                            ? Math.round(loanB[5] * loanAmount)
                            : "0"}
                        </p>

                        <p className="mb-0">
                          <b>Interest Only:</b> $
                          {loanB[6] > 0
                            ? Math.round(loanB[6] * loanAmount)
                            : "N/A"}
                        </p>

                        <p className="mb-0">
                          <b>30 Year Savings: </b>
                          {panelAmount
                            ? loan2Savings.toLocaleString(undefined, {
                                style: "currency",
                                currency: "USD",
                              })
                            : "$0"}
                        </p>
                        <hr></hr>
                        <select
                          className="form-select"
                          onChange={(e) => setLoanB(e.target.value.split(","))}
                        >
                          <option>Change Option 2</option>
                          {mappedLoans}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-3">
                    <div className="card h-100">
                      <div className="card-header">
                        <h5 className="text-center mb-0">Cash</h5>
                      </div>

                      <div className="card-body">
                        <p className="mb-0">
                          <b>Cash Price:</b> $
                          {panelAmount
                            ? cash.toLocaleString(undefined, {
                                style: "currency",
                                currency: "USD",
                              })
                            : "0"}
                        </p>

                        <p className="mb-0">
                          <b>Cash Price Per Watt:</b> {cashPpwDisplay}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row text-dark mt-4">
                  <div className="col-6">
                    <div className="card h-100">
                      <div className="card-header">
                        <h5 className="text-center mb-0">Cost Breakdown</h5>
                      </div>

                      <div className="card-body">
                        <div className="row">
                          <div className="col-6">
                            <p className="mb-0">
                              <b>System Cost:</b>{" "}
                              {panelAmount
                                ? systemCost.toLocaleString(undefined, {
                                    style: "currency",
                                    currency: "USD",
                                  })
                                : "$0"}
                            </p>

                            <p className="mb-0">
                              <b>Down Payment:</b>{" "}
                              {downPayment
                                ? downPayment.toLocaleString(undefined, {
                                    style: "currency",
                                    currency: "USD",
                                  })
                                : "$0"}
                            </p>

                            <p className="mb-0">
                              <b>Federal Tax Incentives:</b>{" "}
                              {panelAmount
                                ? (loanAmount - homeEnergyTotal) * loanA[7]
                                : "$0"}
                            </p>

                            <p className="mb-0">
                              <b>State Tax Incentives:</b>{" "}
                              {panelAmount
                                ? stateTax.toLocaleString(undefined, {
                                    style: "currency",
                                    currency: "USD",
                                  })
                                : "$0"}
                            </p>

                            <p className="mb-0">
                              <b>Loan Amount:</b>{" "}
                              {panelAmount
                                ? loanAmount
                                  ? loanAmount.toLocaleString(undefined, {
                                      style: "currency",
                                      currency: "USD",
                                    })
                                  : systemCost.toLocaleString(undefined, {
                                      style: "currency",
                                      currency: "USD",
                                    })
                                : "$0"}
                            </p>

                            <p className="mb-0">
                              <b>Rebate Amount:</b>{" "}
                              {rebate
                                ? rebate.toLocaleString(undefined, {
                                    style: "currency",
                                    currency: "USD",
                                  })
                                : "$0"}
                            </p>
                          </div>

                          <div className="col-6">
                            <p className="mb-0">
                              <b>REC Amount: </b>
                              {recValue.afterEnergy
                                ? recValue.afterEnergy.toLocaleString(
                                    undefined,
                                    {
                                      style: "currency",
                                      currency: "USD",
                                    },
                                  )
                                : "$0"}
                            </p>
                            <p className="mb-0">
                              <b>Net System Cost: </b>
                              {panelAmount
                                ? netCost.toLocaleString(undefined, {
                                    style: "currency",
                                    currency: "USD",
                                  })
                                : "$0"}
                            </p>
                            <p className="mb-0">
                              <b>Price Per Watt: </b>
                              {+panelAmount > 0
                                ? (systemCost / systemSize).toLocaleString(
                                    undefined,
                                    { style: "currency", currency: "USD" },
                                  )
                                : "$0"}
                            </p>
                            <p className="mb-0">
                              <b>Before adders: </b>
                              {+panelAmount > 0
                                ? (
                                    (systemCost - +adderTotal) /
                                    systemSize
                                  ).toLocaleString(undefined, {
                                    style: "currency",
                                    currency: "USD",
                                  })
                                : "$0"}
                            </p>

                            <p className="mb-0">
                              <b>Net PPW: </b>
                            </p>
                            {overRide ? (
                              <>
                                {+hasRebate === 1 ? (
                                  <>
                                    <p className="mb-0 text-danger">
                                      This price per watt/total cost INCLUDES
                                      the rebate.
                                    </p>
                                  </>
                                ) : (
                                  <></>
                                )}
                                <input
                                  className="form-control"
                                  placeholder="Per Watt Override"
                                  name="basePpw"
                                  type="number"
                                  value={inputBasePpw}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    setInputBasePpw(val);
                                    setBasePpw(val / +dealerFee);
                                  }}
                                />
                                <p className="text-danger">
                                  PPW after rebate:{" "}
                                  {(basePpw - rebatePerWatt).toLocaleString(
                                    undefined,
                                    { style: "currency", currency: "USD" },
                                  )}
                                </p>
                                <input
                                  className="form-control"
                                  placeholder="Total Cost Override"
                                  name="totalCost"
                                  type="number"
                                  value={costOverRide}
                                  onChange={(e) =>
                                    setCostOverRide(e.target.value)
                                  }
                                ></input>
                                {/* <input className='input' placeholder='Rebate Override' name='rebate' onChange={e => setRebate(+e.target.value)}></input> */}
                                <button
                                  type="button"
                                  className="mt-1 btn btn-sm btn-outline-danger"
                                  onClick={() => {
                                    setOverRide(false);
                                    setRebateOverride("0");
                                    setBasePpw("");
                                    setCostOverRide("");
                                  }}
                                >
                                  Cancel
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() => setOverRide(true)}
                                >
                                  Pricing Override
                                </button>
                              </>
                            )}
                            {custUtility === "Pacific Power" ||
                            custUtility === "Portland General Electric (PGE)" ||
                            custUtility === "City Public Service (CPS)" ? (
                              <>
                                {+rebateOverride === 1 ? (
                                  <>
                                    <span>Rebate Override Amount:</span>
                                    <input
                                      className="form-control"
                                      placeholder="Rebate Override"
                                      name="rebateOverrideAmt"
                                      value={rebateOverrideAmt}
                                      onChange={(e) =>
                                        setRebateOverrideAmt(+e.target.value)
                                      }
                                    ></input>
                                    <button
                                      onClick={() => setRebateOverride(0)}
                                    >
                                      Close
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button
                                      onClick={() => setRebateOverride(1)}
                                    >
                                      Rebate Override
                                    </button>
                                    {hybridRebate()}
                                  </>
                                )}
                              </>
                            ) : (
                              <></>
                            )}
                            {maxRebateOverDrive()}
                            {utilityLocation === "Oregon" ? oregonRebate() : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="card h-100">
                      <div className="card-header">
                        <h5 className="text-center mb-0">System Design</h5>
                      </div>

                      <div className="card-body">
                        <div className="row">
                          <div className="col-6">
                            <p className="mb-0">
                              <b>System Size DC:</b>{" "}
                              {systemSize ? systemSize / 1000 : "0"} kW
                            </p>

                            <p className="mb-0">
                              <b>System Size AC:</b>{" "}
                              {(
                                panelAmount *
                                ((mod[4] * inverter[3]) / 1000)
                              ).toFixed(2)}{" "}
                              kW
                            </p>
                            <p className="mb-0">
                              <b>~Panels for 100% offset:</b>{" "}
                              {Math.floor(
                                (totalUsage * 1.1) / ((1700 / 1000) * mod[3]),
                              )}
                              -
                              {Math.floor(
                                (totalUsage * 1.1) / ((1400 / 1000) * mod[3]),
                              )}{" "}
                            </p>
                            <p className="mb-0">
                              <b>~Panels to match bill:</b> {panelEstimate}
                            </p>
                            <hr></hr>
                            <p className="mb-0">
                              <b>Panel: </b> {panelAmount} {mod[1]} {mod[2]}{" "}
                              {mod[3]}
                            </p>
                            <select
                              className="form-select"
                              onChange={(e) =>
                                setMod(e.target.value.split(","))
                              }
                            >
                              <option>Change Panel</option>
                              {mappedModules}
                            </select>

                            <p className="mb-0 mt-2">
                              <b>Inverter: </b>
                              {inverter[1]} {inverter[2]}
                            </p>

                            <select
                              className="form-select"
                              onChange={(e) =>
                                setInverter(e.target.value.split(","))
                              }
                            >
                              <option style={{ display: "none" }}>
                                Change Inverter
                              </option>
                              {mappedInverters}
                            </select>
                          </div>

                          <div className="col-6">
                            <p className="mb-0">
                              <b>Number of panels:</b>
                            </p>

                            <input
                              className={
                                panelAmount < 6
                                  ? "form-control invalidForm"
                                  : "form-control"
                              }
                              onChange={(e) => setPanelAmount(+e.target.value)}
                              value={panelAmount}
                              placeholder="Number of panels"
                              type="number"
                              min="6"
                            ></input>
                            {/*
                            <p className="mb-0 mt-2">
                              <b>Max panels on viable sections:</b>
                            </p>
                            <input
                              className="form-control"
                              onChange={(e) => setMaxModCount(+e.target.value)}
                              value={maxModCount}
                              placeholder="Max # of panels"
                              type="number"
                            ></input>
                            */}
                            <p className="mb-0 mt-2">
                              <b>Number of arrays:</b>
                            </p>
                            <input
                              className="form-control"
                              onChange={(e) => setArrayCount(+e.target.value)}
                              value={arrayCount}
                              placeholder="Number of arrays"
                              type="number"
                            ></input>
                            <p className="mb-0 mt-2">
                              <b>Optional Down Payment:</b>
                            </p>
                            <input
                              className="form-control"
                              placeholder="Down Payment"
                              type="number"
                              value={downPayment}
                              onChange={(e) => setDownPayment(+e.target.value)}
                            ></input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row text-dark mt-4">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header">
                        <h5 className="text-center mb-0">Adders</h5>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-5">
                            <table>
                              <thead>
                                <tr>
                                  <th>Adder</th>
                                  <th>Price w/ dealer fee</th>
                                  <th>Price w/o dealer fee</th>
                                </tr>
                              </thead>
                              <tbody>
                                {adders.map((adder, index) => (
                                  <React.Fragment key={adder.id || index}>
                                    {adder.condition && (
                                      <tr>
                                        <td>{adder.name}</td>
                                        <td>
                                          {convertToCurrency(adder.amount)}
                                        </td>
                                        <td>
                                          {convertToCurrency(
                                            adder.amountNoDealerFee,
                                          )}
                                        </td>
                                      </tr>
                                    )}
                                  </React.Fragment>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="col-7">
                            <div className="row">{adderButtons()}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-4 text-dark">
                  <div className="col-4">
                    <div className="card h-100">
                      <div className="card-header">
                        <h5 className="text-center mb-0">Production</h5>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-12">
                            {props.usageType === "Square Footage" ? (
                              <></>
                            ) : (
                              <p className="mb-0">
                                <b>Offset: </b>
                                {Math.round(
                                  (totalProduction / billCalc[2]) * 100,
                                )}
                                %
                              </p>
                            )}
                            <p>
                              <b>Total Production: </b>
                              {displayProd.toLocaleString(undefined)}kWh
                            </p>

                            {/* <span>Total Production {nest ? (totalProduction - nestAmount).toLocaleString(undefined) : totalProduction.toLocaleString(undefined)}kWh</span> */}

                            <input
                              className="form-control"
                              placeholder="Annual"
                              type="number"
                              value={annualProduction}
                              onChange={(e) =>
                                setAnnualProduction(e.target.value)
                              }
                            ></input>
                          </div>
                          <div className="col-12">
                            <hr></hr>
                          </div>
                          <div className="col-6">
                            <span className="badge bg-warning p-2 mb-1 text-dark w-100">
                              <span className="float-start">January:</span>
                              <span className="float-end">{janProduction}</span>
                            </span>
                            <span className="badge bg-warning p-2 mb-1 text-dark w-100">
                              <span className="float-start">February:</span>
                              <span className="float-end">{febProduction}</span>
                            </span>
                            <span className="badge bg-warning p-2 mb-1 text-dark w-100">
                              <span className="float-start">March:</span>
                              <span className="float-end">{marProduction}</span>
                            </span>
                            <span className="badge bg-warning p-2 mb-1 text-dark w-100">
                              <span className="float-start">April:</span>
                              <span className="float-end">{aprProduction}</span>
                            </span>
                            <span className="badge bg-warning p-2 mb-1 text-dark w-100">
                              <span className="float-start">May:</span>
                              <span className="float-end">{mayProduction}</span>
                            </span>
                            <span className="badge bg-warning p-2 mb-1 text-dark w-100">
                              <span className="float-start">June:</span>
                              <span className="float-end">{junProduction}</span>
                            </span>
                          </div>

                          <div className="col-6">
                            <span className="badge bg-warning p-2 mb-1 text-dark w-100">
                              <span className="float-start">July:</span>
                              <span className="float-end">
                                {julyProduction}
                              </span>
                            </span>
                            <span className="badge bg-warning p-2 mb-1 text-dark w-100">
                              <span className="float-start">August:</span>
                              <span className="float-end">{augProduction}</span>
                            </span>
                            <span className="badge bg-warning p-2 mb-1 text-dark w-100">
                              <span className="float-start">September:</span>
                              <span className="float-end">{sepProduction}</span>
                            </span>
                            <span className="badge bg-warning p-2 mb-1 text-dark w-100">
                              <span className="float-start">October:</span>
                              <span className="float-end">{octProduction}</span>
                            </span>
                            <span className="badge bg-warning p-2 mb-1 text-dark w-100">
                              <span className="float-start">November:</span>
                              <span className="float-end">{novProduction}</span>
                            </span>
                            <span className="badge bg-warning p-2 mb-1 text-dark w-100">
                              <span className="float-start">December:</span>
                              <span className="float-end">{decProduction}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-8">
                    <div className="card h-100">
                      <div className="card-header">
                        <h5 className="text-center mb-0">Questions</h5>
                      </div>
                      <div className="card-body">
                        <div className="row">{questionnaire()}</div>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="row mt-3 text-dark">
                
  <div className="col-12 pt-3" style={{ borderTop: "1px solid #efefef" }}>

  <button
                    type="button"
                    className="btn btn-outline-danger ms-2 float-end"
                    style={{ width: "200px" }}
                    onClick={() => {
                      props.setEdit(false);
                      cancel();
                    }}
                  >
                    Cancel
                  </button>
  <div>
                    <UploadFile setFile={setImg} />
                  </div>
                  {confetti()}

                  {props.customer.solarGrafProjectId &&
                    props.customer.solarGrafDesignId ? (
                      <div>
                        <button
                        type="button"
                        className="btn btn-outline-info ms-2 float-end"
                        style={{ width: "200px" }}
                          onClick={() => handleGetAuroraInfo()}
                          
                        >
                          {loadingDesigns ? (
                            <CircularProgress size={40} color="inherit" />
                          ) : (
                            "Get Aurora Info"
                          )}
                        </button>
                      </div>
                    ) : null}

                  <AuroraDesignModal
                    isOpen={showAuroraDesignModal}
                    onClose={() => {
                      setShowAuroraDesignModal(false);
                      //setAuroraDesigns([]);
                    }}
                    designs={auroraDesigns}
                    onSelectDesign={async (designId) => {
                      await getSolarGrafPropInfo(designId);
                    }}
                    isLoading={loadingDesigns}
                  />

<div>
                      <button
                        type="button"
                        style={{ width: "200px" }}
                        className="btn btn-outline-primary ms-2 float-end"
                        onClick={() => proposal()}
                        
                      >
                        Create Proposal
                      </button>
                    </div>

                    


  </div>
</div>


               

                <div
                  style={{
                    marginTop: "2.7rem",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      width: "70%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        width: "65%",
                      }}
                    >
                      <div className="adders">
                        {/* For whatever reason, this cannot be removed. When removed it breaks react and the useEffects.  */}
                        {false && (
                          <div
                            style={{
                              display: "none",
                              flexDirection: "column",
                              width: "50%",
                              alignItems: "center",
                            }}
                          >
                            <span>Adders</span>
                            <span>w/ dealer fee</span>
                            <span
                              style={{
                                color:
                                  +adderTotal - battery10Amount * battery10 >
                                  +adderMax
                                    ? "rgba(232, 54, 54, 0.82)"
                                    : "",
                              }}
                            >
                              {adderTotal.toLocaleString(undefined, {
                                style: "currency",
                                currency: "USD",
                              })}
                            </span>
                            {travelAdder && (
                              <span className="adderTotal">
                                Travel Adder{" "}
                                {`${travelAdderAmount.toLocaleString(
                                  undefined,
                                  {
                                    style: "currency",
                                    currency: "USD",
                                  },
                                )}`}
                              </span>
                            )}
                            {!!+smallSystemAdder && (
                              <span className="adderTotal">
                                Small System
                                {`${(+smallSystemAdderAmount).toLocaleString(
                                  undefined,
                                  {
                                    style: "currency",
                                    currency: "USD",
                                  },
                                )}`}
                              </span>
                            )}
                            {ionRebate ? (
                              <span className="adderTotal">
                                Rep/Customer{" "}
                                {`${(+adderAmount).toLocaleString(undefined, {
                                  style: "currency",
                                  currency: "USD",
                                })}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {panelBonus ? (
                              <span className="adderTotal">
                                Panel Bonus{" "}
                                {`${(+panelBonusAmount).toLocaleString(
                                  undefined,
                                  {
                                    style: "currency",
                                    currency: "USD",
                                  },
                                )}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {blkAdder ? (
                              <span className="adderTotal">
                                OH/TX BLK{" "}
                                {`${(+adderAmount).toLocaleString(undefined, {
                                  style: "currency",
                                  currency: "USD",
                                })}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {ballast ? (
                              <span className="adderTotal">
                                Ballast{" "}
                                {`${ballastTotal.toLocaleString(undefined, {
                                  style: "currency",
                                  currency: "USD",
                                })}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {groundMount ? (
                              <span className="adderTotal">
                                Ground Mount{" "}
                                {`${groundMountTotal.toLocaleString(undefined, {
                                  style: "currency",
                                  currency: "USD",
                                })}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {pSolar ? (
                              <span className="adderTotal">
                                Pool Solar{" "}
                                {`${Math.ceil(
                                  pSolarAmount * systemSize,
                                ).toLocaleString(undefined, {
                                  style: "currency",
                                  currency: "USD",
                                })}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {msp ? (
                              <span className="adderTotal">
                                MSP{" "}
                                {`${(msp === 1
                                  ? mspAmount
                                  : newMspAmount
                                ).toLocaleString(undefined, {
                                  style: "currency",
                                  currency: "USD",
                                })}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {critterGuard ? (
                              <span className="adderTotal">
                                Critter Guard{" "}
                                {`${(
                                  critterGuardAmount * systemSize
                                ).toLocaleString(undefined, {
                                  style: "currency",
                                  currency: "USD",
                                })}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {battery3 ? (
                              <span className="adderTotal">
                                {" "}
                                {`${battery3Amount.toLocaleString(undefined, {
                                  style: "currency",
                                  currency: "USD",
                                })}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {battery10 > 0 && battery10 < 11 ? (
                              <span className="adderTotal">
                                Enphase Battery{" "}
                                {`${battery10Amount.toLocaleString(undefined, {
                                  style: "currency",
                                  currency: "USD",
                                })}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {battery10 > 20 && battery10 < 31 ? (
                              <span className="adderTotal">
                                Enphase 10c Battery{" "}
                                {`${battery10Amount.toLocaleString(undefined, {
                                  style: "currency",
                                  currency: "USD",
                                })}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {battery10 >= 11 && battery10 < 20 ? (
                              <span className="adderTotal">
                                Tesla Battery{" "}
                                {`${(
                                  battery10Amount *
                                  (battery10 - 10)
                                ).toLocaleString(undefined, {
                                  style: "currency",
                                  currency: "USD",
                                })}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {battery10 >= 11 && battery10 < 20 ? (
                              <span className="adderTotal">
                                Expansion Pack{" "}
                                {`${(
                                  expansionPackAmount * expansionPack
                                ).toLocaleString(undefined, {
                                  style: "currency",
                                  currency: "USD",
                                })}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {treeRemoval ? (
                              <span className="adderTotal">
                                Tree{" "}
                                {`${(+treeRemovalAmount).toLocaleString(
                                  undefined,
                                  {
                                    style: "currency",
                                    currency: "USD",
                                  },
                                )}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {utilityReview ? (
                              <span className="adderTotal">
                                Utility Review{" "}
                                {`${(+utilityReviewAmount).toLocaleString(
                                  undefined,
                                  { style: "currency", currency: "USD" },
                                )}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {reRoof ? (
                              <span className="adderTotal">
                                Reroof{" "}
                                {`${(+reRoofAmount).toLocaleString(undefined, {
                                  style: "currency",
                                  currency: "USD",
                                })}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {+sustainable === 1 ? (
                              <span className="adderTotal">
                                Portland{" "}
                                {`${(0.34 * systemSize).toLocaleString(
                                  undefined,
                                  {
                                    style: "currency",
                                    currency: "USD",
                                  },
                                )}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {loadSwitch ? (
                              <span className="adderTotal">
                                Load Meter Switch{" "}
                                {`${loadSwitchAmount.toLocaleString(undefined, {
                                  style: "currency",
                                  currency: "USD",
                                })}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {townhome ? (
                              <span className="adderTotal">
                                Townhome{" "}
                                {`${townhomeAmount.toLocaleString(undefined, {
                                  style: "currency",
                                  currency: "USD",
                                })}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {nest ? (
                              <span className="adderTotal">
                                Therm{" "}
                                {`${(+nestCost).toLocaleString(undefined, {
                                  style: "currency",
                                  currency: "USD",
                                })}`}
                              </span>
                            ) : (
                              ""
                            )}
                            {pvSystemAddOn ? (
                              <span className="adderTotal">
                                PV System Add-On{" "}
                                {`${pvSystemAddOnAmount.toLocaleString(
                                  undefined,
                                  {
                                    style: "currency",
                                    currency: "USD",
                                  },
                                )}`}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}




          </div>
        </section>
      </>
      {/* )} */}
    </>
  );
};

export default CustomerUsage;
